import { OnInit, EventEmitter, ElementRef, AfterViewInit, OnChanges, OnDestroy, Renderer2 } from '@angular/core';
import { SummaryService } from '../services/summary.service';
import { Summary, SummarySortOption, SummaryColumn, CardImage, ValueSelection, SummaryPage, StackCardBasic, SummaryFunctions, SummaryActions } from '../objects/SummaryObject';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from '../objects/Globals';
import { TokenManager } from '../Globals';
import { ToasterService, ToasterConfig, BodyOutputType } from 'angular2-toaster';
import { Toaster } from '../objects/ToasterObject';
import { ToasterMessageService } from '../services/toaster-message.service';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource, MatTable } from '@angular/material';
import { of, Subject, BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/Rx';
import { ThemeSettingService } from '../services/theme-setting.service';
import { VirtualScrollerComponent } from 'ngx-virtual-scroller';
import { ConfirmationService } from '../services/confirmation.service';
import { WorkspaceService } from '../services/workspace.service';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LoadingSummaryService } from '../services/loading-summary.service';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
import { DetailPopupComponent } from '../detail-popup/detail-popup.component';
import { HeaderService } from '../services/header.service';
import { SwiperDirective } from 'ngx-swiper-wrapper';
import { AttachmentSummary } from '../objects/DetailObject';
import { AttachmentService } from '../services/attachment.service';
import { WorkflowReturnService } from '../services/workflow-return.service';
import { debounceTime } from 'rxjs/operators';
import { EnvService } from '../env.service';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { SidePopupService } from '../services/side-popup.service';
import { FileErrorType } from '../attachment/attachment.component';
var SubSummaryComponent = /** @class */ (function () {
    function SubSummaryComponent(route, globals, summaryService, router, tokenManager, toasterService, toasterMessageService, themeSettingService, confirmationService, workspaceService, attachmentService, sanitizer, modalService, loadingSummaryService, contextMenuService, workflowReturnService, headerService, elRef, renderer, env, sidePopupService) {
        var _this = this;
        this.route = route;
        this.globals = globals;
        this.summaryService = summaryService;
        this.router = router;
        this.tokenManager = tokenManager;
        this.toasterService = toasterService;
        this.toasterMessageService = toasterMessageService;
        this.themeSettingService = themeSettingService;
        this.confirmationService = confirmationService;
        this.workspaceService = workspaceService;
        this.attachmentService = attachmentService;
        this.sanitizer = sanitizer;
        this.modalService = modalService;
        this.loadingSummaryService = loadingSummaryService;
        this.contextMenuService = contextMenuService;
        this.workflowReturnService = workflowReturnService;
        this.headerService = headerService;
        this.elRef = elRef;
        this.renderer = renderer;
        this.env = env;
        this.sidePopupService = sidePopupService;
        this.isDataSet = false;
        this.isSubSummary = false;
        this.filledSpace = 0;
        this.groupFormat = '';
        this.isPreview = false;
        this.isChartTable = false;
        this.autoRefresh = false;
        this.noRelation = false;
        this.displaySummary = true;
        this.fromBroadcast = false;
        this.subSelectedId = new EventEmitter();
        this.subCardSelectedId = new EventEmitter();
        this.popupSelectedId = new EventEmitter();
        this.sortOptions = new EventEmitter();
        this.summaryPage = new EventEmitter();
        this.summaryTotalRows = new EventEmitter();
        this.openPopup = new EventEmitter();
        this.setSummaryName = new EventEmitter();
        this.setPopupTitle = new EventEmitter();
        this.hidePopup = new EventEmitter();
        this.isDualView = new EventEmitter();
        this.isCardView = new EventEmitter();
        this.fetching = new EventEmitter();
        this.setCollapsed = new EventEmitter();
        this.showSummarySettings = new EventEmitter();
        this.isCardImage = new EventEmitter();
        this.isLoadingAsync = new BehaviorSubject(false);
        this.nextPage = new Subject();
        this.isBusy = false;
        this.isCardBusy = false;
        this.ticks = 0;
        this.itemSize = 10;
        this.summaryLength = 10;
        this.animate = true;
        this.isPerformWorkflow = false;
        this.isFav = false;
        this.onGoing = false;
        this.gettingDetail = false;
        this.showAll = true;
        this.dropdownList = new Object();
        this.selectedDropdownValue = new Object();
        this.isImageLoad = true;
        this.noLoading = false;
        this.totalRatioWidth = 0;
        this.treeNodes = [];
        this.markList = [];
        this.isFetching = false;
        this.isFiltering = false;
        this.isFilteredSummary = false;
        this.tableHasData = true;
        this.emitSelectedId = true;
        this.parentArray = [];
        this.selectedArray = [];
        this.isGetSummary = false;
        this.fixLoader = false;
        this.showSummaryMenu = false;
        this.cellsSelected = [];
        this.isLoadingInline = false;
        this.visibleSummaryActions = [];
        this.selectedRowCount = 0;
        this.allSelectedIds = [];
        this.maxFileSizeKb = 10000;
        this.allowedFormats = ["pdf", "png", "jpg", "docx", "doc", "xlsx", "xls", "ppt", "pptx", "pdf", "jpg", "jpeg", "gif", "png", "bmp",
            "dtsconfig", "xml", "dtsx", "mdd", "mcf", "txt", "csv", "zip", "rar", "eml"];
        this.summaryFiles = [];
        this.rowsToUpdate = [];
        this.showNoLoader = false;
        this.rowDataChanged = new Subject();
        this.isBreakdownSummary = false;
        this.hasActionRequiresSelection = false;
        this.nextPageLoaded = false;
        this.isExpandSummary = false;
        this.bsConfig = Object.assign({}, { containerClass: 'theme-blue' });
        this.swiperIndex = 0;
        this.currentDataFile = [];
        this.isFromExpandSummary = false;
        this.indexSet = false;
        this.viewerOptions = {
            navbar: false,
            movable: false,
            toolbar: {
                reset: 4,
                prev: 4,
                play: {
                    show: 4,
                    size: 'large',
                },
                next: 4,
                flipHorizontal: 4,
                flipVertical: 4,
            }
        };
        this.config = new ToasterConfig({
            animation: 'fade',
            timeout: 30000,
            tapToDismiss: false,
            mouseoverTimerStop: true
        });
        this.swiperConfig = {
            direction: 'vertical',
            slidesPerView: 4,
            navigation: true,
            pagination: false,
            mousewheel: true,
            breakpoints: {
                // when window width is <= 480px
                380: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 3
                }
            }
        };
        this.hasChildren = function (_, node) {
            return node.children && node.children.length > 0;
        };
        this.showBudgetIconToolTipText = this.env.showBudgetIconToolTipText;
        this.treeControl = new NestedTreeControl(this.makeGetChildrenFunction());
        this.treeDataSource = new MatTreeNestedDataSource();
        this.treeDataSource.data = this.treeNodes;
        this.sub1 = this.workspaceService.currentParentIdChanged$.subscribe(function (id) {
            if (_this.componentId == id) {
                _this.emitSelectedId = false;
                _this.isBusy = true;
                _this.refreshCard();
            }
        });
        this.sub2 = this.workflowReturnService.isLoadingHomeChanged.subscribe(function (result) {
            if (result) {
                _this.isBusy = true;
            }
            else {
                _this.isBusy = false;
            }
        });
    }
    Object.defineProperty(SubSummaryComponent.prototype, "updateSummary", {
        set: function (update) {
            if (update) {
                this.refreshCard();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubSummaryComponent.prototype, "showSummary", {
        set: function (showSummary) {
            if (showSummary && !this.summary) {
                this.refreshCard();
            }
            else if (!showSummary) {
                this.collapsed = true;
                this.setCollapsed.emit(true);
            }
            else {
                this.collapsed = false;
                this.setCollapsed.emit(false);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubSummaryComponent.prototype, "setSelectedDetailId", {
        set: function (id) {
            this.selectedItemId = id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubSummaryComponent.prototype, "setForceRefresh", {
        set: function (isRefresh) {
            this.refreshCard();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubSummaryComponent.prototype, "setSearchKeyword", {
        set: function (keyword) {
            var _this = this;
            if (keyword != "#trigger") {
                if (this.componentId) {
                    this.keyword = keyword.trim();
                    this.isGetSummary = true;
                    if (this.keyword == '') {
                        this.summaryService.clearKeyword(this.componentId).subscribe(function (result) {
                            if (result == '1') {
                                _this.refreshCard();
                            }
                        });
                    }
                    else {
                        this.searchByKeyword(this.keyword);
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubSummaryComponent.prototype, "changeSortOption", {
        set: function (sortOption) {
            var _this = this;
            if (sortOption) {
                this.summaryService.changeSortType(this.componentId, sortOption.SortField).subscribe(function (result) {
                    if (result) {
                        if (result == '1') {
                            _this.refreshCard();
                        }
                    }
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubSummaryComponent.prototype, "changeSortDirection", {
        set: function (isAscending) {
            var _this = this;
            if (isAscending != null) {
                // this.isBusy = true;
                if (this.componentId) {
                    this.summaryService.changeSortDirection(this.componentId, isAscending.toString()).subscribe(function (result) {
                        if (result) {
                            if (result == '1') {
                                _this.refreshCard();
                            }
                            else {
                                _this.isBusy = false;
                            }
                        }
                    });
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubSummaryComponent.prototype, "setPageSize", {
        set: function (pageSize) {
            this.newPageSize(pageSize);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubSummaryComponent.prototype, "nextPageTrigger", {
        set: function (update) {
            this.nextSlidePage();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubSummaryComponent.prototype, "prevPageTrigger", {
        set: function (update) {
            this.prevSlidePage();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubSummaryComponent.prototype, "changePageTrigger", {
        set: function (selectedPage) {
            this.changePage(selectedPage);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubSummaryComponent.prototype, "componentIdSet", {
        set: function (componentId) {
            if (componentId) {
                if (componentId == 1) {
                    this.animate = true;
                    this.isBusy = false;
                }
                else {
                    this.errorMessage = "";
                    this.componentId = componentId;
                    this.refreshCard();
                }
            }
            else if (componentId == 0) {
                this.animate = false;
                this.isBusy = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubSummaryComponent.prototype, "customInputSet", {
        set: function (value) {
            var _this = this;
            if (value) {
                this.summaryService.UserSelectionInput(this.componentId, value).subscribe(function (result) {
                    _this.refreshCard();
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubSummaryComponent.prototype, "changeLayout", {
        set: function (changeLayout) {
            var _this = this;
            if (changeLayout) {
                this.summaryService.changeSummaryLayout(this.componentId).subscribe(function (result) {
                    if (result == '1') {
                        _this.refreshCard();
                    }
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubSummaryComponent.prototype, "parentScroll", {
        set: function (position) {
            if (this.summaryLayout == "CARDMESSAGES") {
                this.nextPage.next();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubSummaryComponent.prototype, "setExpandSummary", {
        set: function (expandSummary) {
            this.isFromExpandSummary = expandSummary;
        },
        enumerable: true,
        configurable: true
    });
    SubSummaryComponent.prototype.selectTree = function ($event) {
        var _this = this;
        if ($event) {
            this.isBusy = true;
            this.animate = false;
            this.summaryService.selectItem(this.componentId, $event.id).subscribe(function (result) {
                _this.handleWorkflowReturn(result);
                _this.isBusy = false;
                _this.animate = true;
            });
        }
    };
    SubSummaryComponent.prototype.searchByKeyword = function (keyword) {
        var _this = this;
        this.summaryService.searchKeyword(this.componentId, keyword).subscribe(function (result) {
            if (result == '1') {
                _this.refreshCard();
            }
        }, function (error) {
            _this.loadingSummaryService.setLoading(false);
        });
    };
    SubSummaryComponent.prototype.onSelectFile = function (event, summaryRowId) {
        var _this = this;
        if (event.target.files && event.target.files[0]) {
            var reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]); // read file as data url
            reader.onload = function (event) {
                var tree = event.target;
                _this.editablecardUrl.find(function (x) { return x.id == summaryRowId; }).ImageURL = tree.result;
                //this.url = tree.result;
            };
        }
    };
    SubSummaryComponent.prototype.triggerExport = function () {
        var _this = this;
        this.confirmationService.confirm("Export " + this.summary.SummaryName, "<p>Are you sure you want to export all data from this summary? <br/> Please note that the data exported will be sent through the email.</p>", ["NO", "YES"], false)
            .subscribe(function (respond) {
            if (respond.answer == "YES") {
                _this.summaryService.requestEmailSummary(_this.componentId).subscribe(function (result) {
                    if (result) {
                        if (result.toLowerCase() == "true") {
                            _this.toasterMessageService.popToast("Info", "You have requested to export data for " + _this.summary.SummaryName + ". Once the request is ready, you will receive a notification.", "info");
                            //show message or something to the user
                        }
                    }
                });
            }
        });
    };
    SubSummaryComponent.prototype.getImageURL = function (id) {
        return this.editablecardUrl.find(function (x) { return x.id == id; }).ImageURL;
    };
    SubSummaryComponent.prototype.viewAllSummary = function () {
        var _this = this;
        var pageSize = "1000";
        // if (this.showAll){
        //   pageSize = "0"; 
        // }
        this.showAll = !this.showAll;
        this.summaryService.changePageSize(this.componentId, pageSize).subscribe(function (result) {
            if (result) {
                if (result == '1') {
                    _this.refreshCard();
                }
            }
        });
    };
    SubSummaryComponent.prototype.newPageSize = function (pageSize) {
        var _this = this;
        if (this.componentId) {
            if (pageSize) {
                this.summaryService.changePageSize(this.componentId, pageSize).subscribe(function (result) {
                    if (result) {
                        if (result == '1') {
                            _this.refreshCard();
                        }
                    }
                });
            }
        }
    };
    SubSummaryComponent.prototype.prevSlidePage = function () {
        var _this = this;
        if (this.componentId) {
            this.isBusy = true;
            this.summaryService.previousPage(this.componentId).subscribe(function (result) {
                _this.noLoading = true;
                _this.refreshCard();
            });
        }
    };
    SubSummaryComponent.prototype.nextSlidePage = function () {
        var _this = this;
        if (this.componentId) {
            this.isBusy = true;
            this.summaryService.nextPage(this.componentId).subscribe(function (result) {
                _this.noLoading = true;
                _this.refreshCard();
            });
        }
    };
    Object.defineProperty(SubSummaryComponent.prototype, "pageNumbers", {
        get: function () {
            var pages = [];
            var totalPages = this.summary.AvailablePages;
            var currentPage = this.summary.CurrentPage;
            if (totalPages < 5) {
                // If total pages are 5 or less, show all
                for (var i = 1; i <= totalPages; i++) {
                    pages.push(i);
                }
            }
            else {
                // Always show the first page
                pages.push(1);
                // Show ellipsis if the current page is greater than 2
                if (currentPage > 4) {
                    pages.push('...');
                }
                // Show pages around the current page
                var startPage = Math.max(2, currentPage - 2);
                var endPage = Math.min(totalPages - 1, currentPage + 2);
                for (var i = startPage; i <= endPage; i++) {
                    pages.push(i);
                }
                // Show ellipsis if the current page is less than total pages - 2
                if (currentPage < totalPages - 2) {
                    pages.push('...');
                }
                // Always show the last page
                pages.push(totalPages);
            }
            return pages;
        },
        enumerable: true,
        configurable: true
    });
    SubSummaryComponent.prototype.goToPage = function (page) {
        var _this = this;
        if (page >= 1 && page <= this.summary.AvailablePages) {
            if (this.componentId) {
                this.isBusy = true;
                this.summaryService.changePage(this.componentId, page).subscribe(function (result) {
                    _this.noLoading = true;
                    _this.refreshCard();
                });
            }
        }
    };
    SubSummaryComponent.prototype.changePage = function (selectedPage) {
        var _this = this;
        this.isBusy = true;
        if (this.componentId && !this.onGoing) {
            this.onGoing = true;
            this.summaryService.changePage(this.componentId, selectedPage).subscribe(function (result) {
                _this.refreshCard();
                _this.isBusy = false;
                _this.onGoing = false;
            });
        }
    };
    SubSummaryComponent.prototype.selectItem = function (selectedId, forceSelect, showLoading) {
        var _this = this;
        if (forceSelect === void 0) { forceSelect = false; }
        if (showLoading === void 0) { showLoading = false; }
        // this.tokenManager.store("BRNSummarySelectedItem:"+this.componentId, selectedId);
        if (this.parentType) {
            this.emitSelectedItem(selectedId);
            this.selectedItemId = selectedId;
        }
        else {
            this.selectedItemId = selectedId;
            if (!this.isSubSummary)
                this.subSelectedId.emit(0);
            this.isBusy = showLoading;
            this.animate = !showLoading;
            this.summaryService.selectItem(this.componentId, selectedId).subscribe(function (result) {
                _this.handleWorkflowReturn(result, true);
                _this.handleSelectItem(result, forceSelect);
            }, function (error) {
                _this.isBusy = false;
                _this.animate = true;
                _this.subSelectedId.emit(1);
            });
        }
    };
    SubSummaryComponent.prototype.handleSelectItem = function (result, forceSelect) {
        var _this = this;
        var wf = JSON.parse(result);
        if (wf.ReturnType == 3 || wf.ReturnType == 4) {
            var selectedId = wf.Arguments[0];
            var isSubDetail = false;
            var isEmit = false;
            this.summary.Columns.forEach(function (column) {
                if (column.ViewColumnType == "SUBDETAIL") {
                    _this.subDetailId = selectedId;
                    isSubDetail = true;
                }
            });
            if (!isSubDetail) {
                if (forceSelect) {
                    isEmit = true;
                    this.emitSelectedItem(selectedId);
                }
                else {
                    // if (this.previousComponentId != this.componentId){
                    if (this.emitSelectedId) {
                        isEmit = true;
                        this.emitSelectedItem(selectedId);
                    }
                    // }
                }
            }
            if (!isEmit && !this.isSubSummary) {
                this.subSelectedId.emit(1);
            }
            // this is to check whether select item is from a new summary card or existing
            this.previousComponentId = this.componentId;
        }
    };
    SubSummaryComponent.prototype.makeGetChildrenFunction = function () {
        return function (node) { return of(node.children); };
    };
    SubSummaryComponent.prototype.popToast = function (title, body, type) {
        var _this = this;
        var toast = {
            type: type,
            title: title,
            body: body,
            showCloseButton: true,
            bodyOutputType: BodyOutputType.TrustedHtml,
            onShowCallback: function (toast) {
                var toaster = new Toaster();
                toaster.id = toast.toastId;
                toaster.timestamp = Date.now();
                toaster.title = toast.title;
                toaster.content = toast.body;
                _this.toasterMessageService.pushToaster(toaster);
            }
        };
        this.toasterService.pop(toast);
    };
    SubSummaryComponent.prototype.checkIfHasError = function (id) {
        var _this = this;
        var noError = true;
        if (id) {
            if (id.startsWith("ERROR:")) {
                noError = false;
                this.componentId = "";
                this.errorMessage = id.substr(6, id.length - 1);
                setTimeout(function () {
                    _this.isCardBusy = false;
                    _this.isBusy = false;
                });
            }
            else {
                noError = true;
            }
        }
        return noError;
    };
    SubSummaryComponent.prototype.refreshCard = function (selectItem) {
        var _this = this;
        if (selectItem === void 0) { selectItem = true; }
        if (this.checkIfHasError(this.componentId)) {
            if (!this.noLoading) {
                this.delayUpdateVariable(true);
            }
            if (!this.showNoLoader)
                this.fixLoader = true;
            if (this.componentId && this.globals.Session) {
                this.summaryService.getSummary(this.componentId).subscribe(function (result) {
                    _this.isGetSummary = false;
                    _this.fixLoader = false;
                    _this.isFetching = false;
                    _this.currentDataFile = [];
                    _this.summaryService.setEnableSearch(true);
                    _this.summary = JSON.parse(result);
                    _this.currentSummaryData = _this.summary.Data;
                    _this.storeIfSelectAll();
                    if (_this.summary) {
                        if (selectItem) {
                            _this.summaryService.getSelectedId(_this.componentId).subscribe(function (selectedId) {
                                if (selectedId) {
                                    _this.selectItem(selectedId);
                                }
                                else {
                                    _this.previousComponentId = _this.componentId;
                                }
                            });
                        }
                        _this.setSummaryName.emit(_this.summary.SummaryName);
                        _this.setPopupTitle.emit(_this.summary.HeaderText);
                        _this.summaryTotalRows.emit(_this.summary.TotalRows);
                        _this.isDualView.emit(_this.summary.IsDualView);
                        _this.loadingSummaryService.setLoading(false);
                        _this.sortSummaryActions();
                        _this.handleSummarySelection();
                        _this.handleSummaryFunctions();
                        _this.handleActionSave();
                        _this.visibleSummaryActions = _this.summary.Actions.filter(function (x) { return !x.IsHidden; });
                        if (_this.summary.SystemSummaryName) {
                            _this.summary.SummaryClass = _this.summary.SystemSummaryName.replace(/\s/g, "_");
                        }
                        _this.summaryPage.emit({ currentPage: _this.summary.CurrentPage, availablePage: _this.summary.AvailablePages });
                        if (_this.summary.CardLayoutProperties.length > 0) {
                            _this.summaryLayout = _this.summary.CardLayoutProperties[0].LayoutType.toUpperCase();
                            _this.idColumn = _this.summary.CardLayoutProperties.find(function (x) { return x.CardProperty.toUpperCase() == "ID"; }).PropertyName;
                            _this.isCardView.emit(true);
                            if (_this.summaryLayout == "CARDIMAGE")
                                _this.isCardImage.emit(true);
                        }
                        else {
                            if (_this.summary.SummaryDisplay == "TABLEADVANCED") {
                                _this.summaryLayout = "TABLEADVANCED";
                            }
                            else {
                                _this.summaryLayout = "TABLE";
                                _this.idColumn = _this.summary.Columns.find(function (x) { return x.IsID; }).PropertyName;
                                if (_this.isFiltering) {
                                    _this.isFiltering = false;
                                }
                                if (_this.summary.Data.length > 0) {
                                    _this.tableHasData = true;
                                }
                                else {
                                    _this.tableHasData = false;
                                    // var dummyData = {data: "no data"};
                                    // this.summary.Data.push(dummyData);
                                }
                            }
                            _this.isCardView.emit(false);
                        }
                        if (_this.isInlineControls) {
                            //this.handleInlineControls();
                        }
                        _this.summary.Data.forEach(function (data) {
                            _this.summary.Columns.forEach(function (column) {
                                if (column.ViewColumnType == "COMBOBOX") {
                                    if (column.AdditionalInfo) {
                                        column.AdditionalInfo.forEach(function (info) {
                                            info.SelectionValue = info.SelectionValue.toLowerCase();
                                        });
                                    }
                                }
                                else if (column.ViewColumnType == "FILE") {
                                    // if (data[column.PropertyName]){
                                    //   this.attachmentService.downloadFile(data[column.PropertyName].split('|')[0]).subscribe(result=>{
                                    //     data['fileURL'] = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(result));
                                    //     this.currentDataFile.push({id: data[this.idColumn], fileUrl: data['fileURL']});
                                    //   });
                                    // }
                                }
                                else if (column.ViewColumnType == "FILEUPLOAD") {
                                    // if (data[column.PropertyName]){
                                    _this.getFileList(data, column);
                                    _this.getFilesSettings();
                                    // }
                                }
                                else if (column.ViewColumnType) {
                                    if (column.AdditionalParameter) {
                                        if (column.AdditionalParameter.indexOf('Expand') > -1) {
                                            _this.isBreakdownSummary = true;
                                        }
                                    }
                                }
                            });
                        });
                        _this.summaryData = _this.sortSummaryData(_this.summary.Data);
                        _this.cloneSummaryData = JSON.parse(JSON.stringify(_this.summaryData));
                        _this.getVisibleColumns();
                        _this.totalRatioWidth = 0;
                        _this.visibleColumns.forEach(function (element) {
                            _this.totalRatioWidth = _this.totalRatioWidth + element.WidthWeight;
                        });
                        if (_this.isPreview)
                            _this.summary.SelectionType = null;
                        if (_this.isChartTable) {
                            var timer = Observable.timer(1000, _this.env.checkIntervalUpdate ? _this.env.checkIntervalUpdate * 1000 : 5000);
                            if (_this.sub5)
                                _this.sub5.unsubscribe();
                            _this.sub5 = timer.subscribe(function (t) { return _this.checkIfSummaryHasUpdate(); });
                        }
                        _this.handleHeaderAndFooter();
                        _this.constructObjectByLayout();
                        _this.summaryData = _this.parseValueForMultiCombobox(_this.summary, _this.summaryData);
                        _this.sortOptionList = _this.summary.SortOptions;
                        _this.sortOptions.emit(_this.summary.SortOptions);
                        if (_this.isChartTable && _this.previousComponentId == _this.componentId) {
                            _this.summaryService.setSummaryUpdate(true);
                        }
                    }
                    _this.delayUpdateVariable(false);
                    _this.autoRefresh = false;
                    _this.collapsed = false;
                    _this.showNoLoader = false;
                    _this.setCollapsed.emit(false);
                }, function (error) {
                    _this.isBusy = false;
                });
            }
            else if (this.parentId && this.groupId) {
                this.summaryService.getNewSummaryFromDetail(this.parentId, this.groupId, this.noRelation).subscribe(function (result) {
                    if (result.startsWith("ERROR:")) {
                        _this.errorMessage = result.substr(6, result.length - 1);
                        _this.removeCardLoading();
                    }
                    else {
                        _this.componentId = result;
                        if (_this.componentId) {
                            _this.refreshCard();
                        }
                        else {
                            _this.removeCardLoading();
                        }
                    }
                });
            }
            else if (this.parentId && this.propertyId) {
                this.summaryService.getDataSetSummaryFromDetail(this.parentId, this.propertyId).subscribe(function (result) {
                    if (result.startsWith("ERROR:")) {
                        _this.errorMessage = result.substr(6, result.length - 1);
                        _this.removeCardLoading();
                    }
                    else {
                        _this.componentId = result;
                        if (_this.componentId) {
                            _this.refreshCard();
                        }
                        else {
                            _this.removeCardLoading();
                        }
                    }
                });
            }
        }
    };
    SubSummaryComponent.prototype.refreshCardCurrentPage = function (selectItem, currentPage) {
        var _this = this;
        if (selectItem === void 0) { selectItem = true; }
        if (this.componentId) {
            this.isBusy = true;
            this.summaryService.changePage(this.componentId, currentPage).subscribe(function (result) {
                _this.noLoading = true;
                _this.refreshCard();
            });
        }
    };
    SubSummaryComponent.prototype.downloadFileCol = function (row, column) {
        var _this = this;
        this.isBusy = true;
        this.animate = false;
        this.attachmentService.downloadFile(row[column.PropertyName].split('|')[0]).subscribe(function (result) {
            // row['fileURL'] = this.sanitizer.bypassSecurityTrustHtml(window.URL.createObjectURL(result));
            // this.currentDataFile.push({id: row[this.idColumn], fileUrl: row['fileURL']});
            _this.isBusy = false;
            _this.animate = true;
            _this.downloadFile(result, row[column.PropertyName].split('|')[1]);
        }, function (error) {
            _this.isBusy = false;
            _this.animate = true;
        });
    };
    SubSummaryComponent.prototype.onMatTableScroll = function (e) {
        var _this = this;
        if (this.summary.CurrentPage == this.summary.AvailablePages || this.isExpandSummary)
            return;
        var tableViewHeight = e.target.offsetHeight; // viewport: ~500px
        var tableScrollHeight = e.target.scrollHeight; // length of all table
        var scrollLocation = e.target.scrollTop; // how far user scrolled
        // If the user has scrolled within 200px of the bottom, add more data
        var buffer = 200;
        var limit = tableScrollHeight - tableViewHeight - buffer;
        if (scrollLocation > limit) {
            if (!this.isFetching) {
                this.isFetching = true;
                this.fetching.emit(true);
                this.fetchNextChunk().then(function (chunk) {
                    // this.summaryData = chunk;
                    _this.formatNextData(chunk);
                    _this.currentSummaryData = _this.summaryData;
                    _this.cloneSummaryData = JSON.parse(JSON.stringify(_this.summaryData));
                    _this.storeIfSelectAll();
                    _this.isFetching = false;
                    _this.fetching.emit(false);
                    _this.loadMoreImages();
                }, function () { return _this.isFetching = false; });
            }
        }
    };
    SubSummaryComponent.prototype.loopGetNextSummary = function () {
        var _this = this;
        this.isFetching = true;
        this.fetching.emit(true);
        this.fetchNextChunk().then(function (chunk) {
            // this.summaryData = chunk;
            _this.formatNextData(chunk);
            _this.currentSummaryData = _this.summaryData;
            _this.cloneSummaryData = JSON.parse(JSON.stringify(_this.summaryData));
            _this.storeIfSelectAll();
            _this.isFetching = false;
            _this.fetching.emit(false);
            _this.loadMoreImages();
            if (_this.tableContainer && _this.isFromExpandSummary) {
                if (_this.tableContainer.nativeElement.scrollHeight <= _this.tableContainer.nativeElement.clientHeight) {
                    // means no scrollbar
                    if (_this.summary.CurrentPage < _this.summary.AvailablePages) {
                        _this.loopGetNextSummary();
                    }
                }
            }
        }, function () { return _this.isFetching = false; });
    };
    SubSummaryComponent.prototype.formatNextData = function (summaryData) {
        var _this = this;
        summaryData.forEach(function (data) {
            _this.summary.Columns.forEach(function (column) {
                if (column.ViewColumnType == "COMBOBOX") {
                    if (column.AdditionalInfo) {
                        column.AdditionalInfo.forEach(function (info) {
                            info.SelectionValue = info.SelectionValue.toLowerCase();
                        });
                    }
                }
                else if (column.ViewColumnType == "FILE") {
                    // if (data[column.PropertyName]){
                    //   if (this.currentDataFile.find(x => x.id == data[this.idColumn])){
                    //     data['fileURL'] = this.currentDataFile.find(x => x.id == data[this.idColumn]).fileUrl;
                    //   }
                    //   else{
                    //     this.attachmentService.downloadFile(data[column.PropertyName].split('|')[0]).subscribe(result=>{
                    //       data['fileURL'] = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(result));
                    //       this.currentDataFile.push({id: data[this.idColumn], fileUrl: data['fileURL']});
                    //     });
                    //   }
                    // }
                }
                else if (column.ViewColumnType == "FILEUPLOAD") {
                    // if (data[column.PropertyName]){
                    _this.getFileList(data, column);
                    // }
                }
                else if (column.ViewColumnType) {
                    if (column.AdditionalParameter) {
                        if (column.AdditionalParameter.indexOf('Expand') > -1) {
                            _this.isBreakdownSummary = true;
                        }
                    }
                }
            });
        });
        if (this.summaryData && summaryData) {
            this.summaryData.forEach(function (data) {
                if (data["selected"]) {
                    var exactData = summaryData.find(function (x) { return x[_this.idColumn] == data[_this.idColumn]; });
                    if (exactData) {
                        exactData["selected"] = data["selected"];
                    }
                }
            });
        }
        this.summaryData = this.sortSummaryData(summaryData);
    };
    SubSummaryComponent.prototype.log = function (event) {
        console.log(event);
    };
    SubSummaryComponent.prototype.removeCardLoading = function () {
        this.fixLoader = false;
        this.isCardBusy = false;
        this.delayUpdateVariable(false);
    };
    SubSummaryComponent.prototype.delayUpdateVariable = function (bool) {
        var _this = this;
        if (bool === void 0) { bool = false; }
        setTimeout(function () {
            _this.isBusy = bool;
        });
    };
    SubSummaryComponent.prototype.handleSummarySelection = function () {
        var _this = this;
        this.summary.Actions.forEach(function (action) {
            _this.checkButtonDisabled(action);
        });
        if (this.hasActionRequiresSelection) {
            this.summary.ShowCheckmark = true;
        }
    };
    SubSummaryComponent.prototype.sortSummaryActions = function () {
        this.summary.Actions = this.summary.Actions.sort(function (a, b) {
            if (a.ActionOrder > b.ActionOrder) {
                return 1;
            }
            else if (a.ActionOrder < b.ActionOrder) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    SubSummaryComponent.prototype.handleInlineControls = function () {
        this.isLoadingInline = true;
        this.loopInlineControls(this.summary.Data, 0);
    };
    SubSummaryComponent.prototype.loopInlineControls = function (data, index) {
        var _this = this;
        this.summaryService.selectItem(this.componentId, data[index][this.idColumn]).subscribe(function (result) {
            if (result) {
                data[index]['detailId'] = result;
                index++;
                if (data.length > index) {
                    _this.loopInlineControls(data, index);
                }
                else {
                    _this.isLoadingInline = false;
                }
            }
        }, function (error) {
            _this.isLoadingInline = false;
        });
    };
    SubSummaryComponent.prototype.calcColumnsLength = function () {
        this.columnsLength = this.visibleColumns.length;
        if (this.summary.SelectionType == 'SINGLE' || this.summary.SelectionType == 'MULTI') {
            this.columnsLength++;
        }
        if (this.summary.ColumnHasSearch) {
            this.columnsLength++;
        }
    };
    SubSummaryComponent.prototype.filterByColumn = function (keyword, columnName, isMultiValue) {
        var _this = this;
        if (isMultiValue === void 0) { isMultiValue = false; }
        if (keyword == null)
            return false;
        if (isMultiValue && keyword.length == 0) {
            keyword = "";
        }
        else {
            // tie current keyword to column instead
            // if (JSON.stringify(this.filterKeyword) === JSON.stringify(keyword)){
            //   return false;
            // }
        }
        if (isMultiValue && keyword) {
            var values = keyword;
            var newKeyword = [];
            this.visibleColumns.find(function (x) { return x.PropertyName == columnName; }).FilterValueSelection.forEach(function (lookup) {
                if (values.findIndex(function (x) { return x == lookup.SelectionValue; }) > -1) {
                    newKeyword.push(lookup.SelectionDisplay);
                }
            });
            keyword = newKeyword;
        }
        this.filterKeyword = keyword;
        this.animate = false;
        this.isBusy = true;
        this.summaryService.FilterColumnByValue(this.componentId, columnName, keyword).subscribe(function (result) {
            if (result == "1") {
                _this.isFiltering = true;
                _this.animate = true;
                _this.isFilteredSummary = true;
                _this.isSelectAll = false;
                // if (this.summary.ShowCheckmark)
                // {
                //   this.refreshCard();
                // }
                // else
                // {
                _this.refreshCard(false);
                // }
            }
        }, function (error) {
            _this.animate = true;
            _this.isBusy = false;
        });
    };
    SubSummaryComponent.prototype.selectAll = function () {
        var _this = this;
        this.isSelectAll = !this.isSelectAll;
        this.markList = [];
        if (this.isSelectAll) {
            this.currentSummaryData.forEach(function (data) {
                _this.markList.push(data[_this.idColumn]);
                _this.getSelectionValues(data);
            });
            this.selectedRowCount = this.summary.TotalRows;
            this.summaryService.checkAllItems(this.componentId).subscribe(function (result) {
                _this.allSelectedIds = JSON.parse(result);
            });
        }
        else {
            this.currentSummaryData.forEach(function (data) {
                _this.getSelectionValues(data);
            });
            this.selectedRowCount = 0;
            this.markList = [];
            this.parentArray = [];
            this.allSelectedIds = [];
            this.summaryService.uncheckAllItems(this.componentId).subscribe(function (result) {
                //console.log(result);
            });
        }
        this.summary.Actions.forEach(function (action) {
            _this.checkButtonDisabled(action);
        });
    };
    SubSummaryComponent.prototype.onFilterChanged = function (propertyName) {
        this.visibleColumns.find(function (x) { return x.PropertyName == propertyName; }).IsFilterChanged = true;
    };
    SubSummaryComponent.prototype.clear = function (propertyName, select) {
        this.visibleColumns.find(function (x) { return x.PropertyName == propertyName; }).IsFilterChanged = true;
        setTimeout(function () {
            select.focus();
        });
    };
    SubSummaryComponent.prototype.clearAllFilter = function () {
        var _this = this;
        this.animate = false;
        this.isBusy = true;
        this.filterKeyword = null;
        this.summaryService.ClearColumnFilter(this.componentId).subscribe(function (result) {
            _this.animate = true;
            _this.isBusy = false;
            _this.isFilteredSummary = false;
            _this.refreshCard();
        });
    };
    SubSummaryComponent.prototype.constructObjectByLayout = function () {
        var _this = this;
        if (this.summaryLayout == "CARDIMAGE" || this.summaryLayout == "CARDIMAGEDETAIL" || this.summaryLayout == "SUMMARYSUPPLIER"
            || this.summaryLayout == "CARDIMAGEBASIC" || this.summaryLayout == "CARDOPTION" || this.summaryLayout == "CARDIMAGEWIDE"
            || this.summaryLayout == "CARDOPTIONWIDE") {
            this.populateImage(this.retrieveDataByCardProperty('Image'));
        }
        else if (this.summaryLayout == "CARDBASIC") {
            this.stackCardBasic = [];
            this.summary.Data.forEach(function (element) {
                if (element[_this.retrieveDataByCardProperty('grp')] != null) {
                    var i = 1;
                    var g = _this.stackCardBasic.filter(function (x) { return x.GroupId == element[_this.retrieveDataByCardProperty('grp')]; });
                    var stackNum = i + g.length;
                    if (g.length > 0) {
                        if (stackNum > 3)
                            stackNum = 4;
                        _this.stackCardBasic.find(function (x) { return x.GroupId == element[_this.retrieveDataByCardProperty('grp')]; }).Type = 'multi';
                        _this.stackCardBasic.push({
                            StackNo: stackNum,
                            GroupId: element[_this.retrieveDataByCardProperty('grp')],
                            Id: element[_this.retrieveDataByCardProperty('ID')],
                            Type: '',
                            ToggleNo: 1,
                            ShowCards: false
                        });
                    }
                    else {
                        _this.stackCardBasic.push({
                            StackNo: stackNum,
                            GroupId: element[_this.retrieveDataByCardProperty('grp')],
                            Id: element[_this.retrieveDataByCardProperty('ID')],
                            Type: '',
                            ToggleNo: 1,
                            ShowCards: false
                        });
                    }
                }
            });
        }
        else if (this.summaryLayout == "EDITABLECARD") {
            this.editablecardUrl = [];
            this.summary.Data.forEach(function (element) {
                _this.editablecardUrl.push({
                    id: element[_this.retrieveDataByCardProperty('ID')],
                    imageURL: ''
                });
            });
        }
        else if (this.summaryLayout == "CARDMESSAGES") {
            var timer = Observable.timer(1000, this.env.checkIntervalUpdate ? this.env.checkIntervalUpdate * 1000 : 5000);
            if (this.sub4)
                this.sub4.unsubscribe();
            this.sub4 = timer.subscribe(function (t) { return _this.checkIfSummaryHasUpdate(true); });
        }
        else if (this.summaryLayout == "CARDINPUT") {
            var timer = Observable.timer(1000, this.env.checkIntervalUpdate ? this.env.checkIntervalUpdate * 1000 : 5000);
            if (this.sub6)
                this.sub6.unsubscribe();
            //this.sub6 = timer.subscribe(t => this.checkIfSummaryHasUpdate(true));
        }
        else if (this.summaryLayout == "HIERARCHY" || this.summaryLayout == "HIERARCHYVIEW") {
            this.buildTree(this.summary.Data);
        }
        else if (this.summaryLayout == "TABLE") {
            this.calcColumnsLength();
            var imageColumn = this.summary.Columns.find(function (x) { return x.ViewColumnType == "IMAGE"; });
            if (imageColumn) {
                this.populateImage(imageColumn.PropertyName);
            }
        }
    };
    SubSummaryComponent.prototype.populateImage = function (imageColumnName) {
        var _this = this;
        if (this.summary.Data.length > 0) {
            this.imageObject = [];
            this.imageId = [];
            this.summary.Data.forEach(function (element) {
                // set the id
                if (element[imageColumnName] != null) {
                    var docId_1 = element[_this.idColumn];
                    var array = element[imageColumnName].split(",");
                    array.forEach(function (imageId) {
                        if (!imageId) {
                            imageId = '00000000-0000-0000-0000-000000000000';
                        }
                        _this.imageId.push(imageId);
                        _this.imageObject.push({ docId: docId_1, imageId: imageId });
                    });
                }
            });
            this.getAllImage();
            setTimeout(function () {
                _this.isImageLoad = false;
            }, 15000);
        }
    };
    SubSummaryComponent.prototype.checkmark = function ($event, row) {
        var _this = this;
        // if (this.isSelectAll) this.isSelectAll = false;
        // store selectedid/s in a list depending on selection type
        if (this.summary.SelectionType == 'SINGLE') {
            if (this.markList[0] == row[this.idColumn]) {
                this.markList = [];
            }
            else {
                this.markList[0] = row[this.idColumn];
            }
        }
        else if (this.summary.SelectionType == 'MULTI') {
            if (this.markList.indexOf(row[this.idColumn]) > -1) {
                this.selectedRowCount--;
                this.markList.splice(this.markList.indexOf(row[this.idColumn]), 1);
            }
            else {
                this.selectedRowCount++;
                this.markList.push(row[this.idColumn]);
            }
        }
        if (this.markList.length == this.summary.TotalRows) {
            this.isSelectAll = true;
            this.summaryService.checkAllItems(this.componentId).subscribe(function (result) {
                _this.allSelectedIds = JSON.parse(result);
            });
        }
        else {
            this.isSelectAll = false;
            if (this.selectedRowCount == this.summary.TotalRows)
                this.isSelectAll = true;
        }
        var param = this.getSelectionValues(row);
        if (this.markList.indexOf(row[this.idColumn]) > -1) {
            this.selectedArray.push(row);
            this.summaryService.checkItem(this.componentId, row[this.idColumn], param).subscribe(function (result) {
                //console.log(result);
                // handle
            });
        }
        else {
            this.selectedArray.splice(this.selectedArray.findIndex(function (x) { return x[_this.idColumn] == row[_this.idColumn]; }), 1);
            this.summaryService.uncheckItem(this.componentId, row[this.idColumn]).subscribe(function (result) {
                //console.log(result);
                // handle
            });
        }
        this.summary.Actions.forEach(function (action) {
            _this.checkButtonDisabled(action);
        });
        // this.summaryService.selectItems(this.componentId, this.markList).subscribe(result=>{
        //   if (result == "1"){
        //     // show loading end
        //   }
        // });
        // $event.preventDefault(); 
        // $event.stopPropagation();
    };
    SubSummaryComponent.prototype.getSelectionValues = function (row) {
        var _this = this;
        var param;
        // get selectedvalues for each column in this row, and store in a list => arr
        if (this.summaryLayout == "TABLE") {
            var arr = [];
            if (this.markList.indexOf(row[this.idColumn]) > -1) {
                this.summary.Columns.forEach(function (column) {
                    if (column.IsID) {
                        arr.push({ name: column.PropertyName, value: row[column.PropertyName] });
                    }
                    if (column.ViewColumnType == 'EDITABLETEXT' || column.ViewColumnType == 'EDITABLEDATE' || column.ViewColumnType == 'COMBOBOX' || column.ViewColumnType == 'MULTICOMBOBOX') {
                        arr.push({ name: column.PropertyName, value: column.ViewColumnType == 'COMBOBOX' ? row[column.PropertyName] : JSON.stringify(row[column.PropertyName]) });
                        param = { property: column.PropertyName, value: row[column.PropertyName] };
                    }
                });
            }
            else {
                var index = this.parentArray.findIndex(function (x) { return x.id == row[_this.idColumn]; });
                this.parentArray.splice(index, 1);
                if (this.allSelectedIds.find(function (x) { return x == row[_this.idColumn]; })) {
                    this.allSelectedIds.splice(this.allSelectedIds.findIndex(function (x) { return x == row[_this.idColumn]; }), 1);
                }
            }
            if (arr.length > 0) {
                if (this.summary.SelectionType == "SINGLE")
                    this.parentArray = [];
                if (this.parentArray.filter(function (x) { return x.id == row[_this.idColumn]; }).length == 0) {
                    this.parentArray.push({ id: row[this.idColumn], value: arr });
                }
            }
        }
        return param;
    };
    SubSummaryComponent.prototype.sortBySummaryColumn = function (name) {
        var _this = this;
        this.isBusy = true;
        this.animate = false;
        this.summaryService.ChangeSummaryTableSorting(this.componentId, name).subscribe(function (result) {
            if (result == "1") {
                _this.emitSelectedId = false;
                _this.showNoLoader = true;
                _this.refreshCard();
            }
        }, function (error) {
            _this.isBusy = false;
            _this.animate = true;
        });
    };
    SubSummaryComponent.prototype.fetchMore = function (event) {
        var _this = this;
        if (this.summary.CurrentPage == this.summary.AvailablePages || this.isExpandSummary)
            return;
        if (event.endIndex == this.summaryData.length - 1) {
            if (!this.isFetching && !this.isGetSummary) {
                this.isFetching = true;
                this.fetching.emit(true);
                this.fetchNextChunk().then(function (chunk) {
                    _this.summaryData = chunk;
                    _this.currentSummaryData = _this.summaryData;
                    _this.cloneSummaryData = JSON.parse(JSON.stringify(_this.summaryData));
                    _this.storeIfSelectAll();
                    _this.isFetching = false;
                    _this.fetching.emit(false);
                    _this.loadMoreImages();
                }, function () { return _this.isFetching = false; });
            }
        }
        ;
    };
    SubSummaryComponent.prototype.getNextSummary = function () {
        var _this = this;
        this.isLoadingAsync.next(true);
        this.isFetching = true;
        this.fetchNextChunk().then(function (chunk) {
            _this.summaryData = chunk;
            _this.currentSummaryData = _this.summaryData;
            _this.storeIfSelectAll();
            _this.loadMoreImages();
            _this.nextPageLoaded = true;
            _this.isLoadingAsync.next(false);
            _this.isFetching = false;
        }, function (error) {
            _this.isLoadingAsync.next(false);
            _this.isFetching = false;
        });
    };
    SubSummaryComponent.prototype.fetchNextChunk = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.isGetSummary) {
                reject('summary refreshed from other place');
            }
            _this.summaryService.nextPage(_this.componentId).subscribe(function (returns) {
                if (returns == "1") {
                    _this.summaryService.getSummary(_this.componentId).subscribe(function (result) {
                        var summary = JSON.parse(result);
                        _this.summary.CurrentPage = summary.CurrentPage;
                        summary = _this.handleSummaryImages(summary);
                        resolve(summary.Data);
                    });
                }
            });
        });
    };
    SubSummaryComponent.prototype.handleSummaryImages = function (summary) {
        var _this = this;
        if (summary.Data.length > 0) {
            this.nextImageObject = [];
            this.nextImageId = [];
            summary.Data.forEach(function (element) {
                // set the id
                if (element[_this.retrieveDataByCardProperty('Image')] != null) {
                    var docId_2 = element[_this.retrieveDataByCardProperty('ID')];
                    var array = element[_this.retrieveDataByCardProperty('Image')].split(",");
                    array.forEach(function (imageId) {
                        if (!imageId) {
                            imageId = '00000000-0000-0000-0000-000000000000';
                        }
                        if (_this.imageId.indexOf(imageId) > -1) {
                            _this.imageId.push(imageId);
                            _this.imageObject.push({ docId: docId_2, imageId: imageId });
                        }
                        else {
                            _this.nextImageId.push(imageId);
                            _this.nextImageObject.push({ docId: docId_2, imageId: imageId });
                        }
                    });
                }
            });
        }
        summary.Data = this.sortSummaryData(summary.Data);
        summary.Data = this.parseValueForMultiCombobox(summary, summary.Data);
        return summary;
    };
    // performance experimental fix
    SubSummaryComponent.prototype.loadMoreImages = function () {
        var _this = this;
        if (this.nextImageObject) {
            if (this.nextImageId.length > 0) {
                // this.isImageLoad = true;
                this.promiseNextImage(this.nextImageId, this.nextImageObject).then(function (chunk) {
                    _this.currentCardImage = chunk;
                    _this.summary.CardImageList = chunk;
                });
            }
        }
    };
    SubSummaryComponent.prototype.promiseNextImage = function (imageIds, imageObject) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var list = _this.currentCardImage;
            _this.summaryService.getAllImage(imageIds).subscribe(function (results) {
                var index = 0;
                var _loop_1 = function (result) {
                    result = new Blob([result], { type: 'image/jpg' });
                    var docId = imageObject.find(function (x) { return x.imageId == imageIds[index]; }).docId;
                    var reader = new FileReader();
                    reader.addEventListener("load", function () {
                        list.push({
                            DocumentId: docId,
                            ImageId: imageIds[index],
                            Blob: reader.result
                        });
                    }, false);
                    _this.imageId.push(imageIds[index]);
                    if (result) {
                        reader.readAsDataURL(result);
                    }
                    index++;
                };
                for (var _i = 0, results_1 = results; _i < results_1.length; _i++) {
                    var result = results_1[_i];
                    _loop_1(result);
                }
            });
            resolve(list);
        });
    };
    SubSummaryComponent.prototype.parseValueForMultiCombobox = function (summary, summaryData) {
        var _this = this;
        var columnName = ""; // for now its working for only one multicombobox per row
        // get columnName for multicombobox
        summary.Columns.forEach(function (column) {
            if (column.ViewColumnType == "MULTICOMBOBOX") {
                columnName = column.PropertyName;
            }
        });
        if (columnName) {
            // change type of the data to be an array
            this.selectedArray.forEach(function (row) {
                if (summaryData.find(function (x) { return x[_this.idColumn] == row[_this.idColumn]; })) {
                    if (summaryData.find(function (x) { return x[_this.idColumn] == row[_this.idColumn]; })[columnName]) {
                        summaryData.find(function (x) { return x[_this.idColumn] == row[_this.idColumn]; })[columnName] = JSON.parse(summaryData.find(function (x) { return x[_this.idColumn] == row[_this.idColumn]; })[columnName]);
                    }
                }
            });
        }
        return summaryData;
    };
    SubSummaryComponent.prototype.getNestedChildren = function (arr, parent) {
        var out = [];
        for (var i in arr) {
            if (arr[i].parent == parent) {
                var children = this.getNestedChildren(arr, arr[i].id);
                if (children.length) {
                    arr[i].children = children;
                }
                out.push(arr[i]);
            }
        }
        return out;
    };
    SubSummaryComponent.prototype.getFilteredList = function (array, key, value) {
        return array.filter(function (o) {
            return o[key] == value;
        });
    };
    SubSummaryComponent.prototype.getStack = function (id) {
        var stack = 1;
        if (!id)
            return false;
        if (this.stackCardBasic.find(function (x) { return x.Id == id; }))
            stack = this.stackCardBasic.find(function (x) { return x.Id == id; }).StackNo;
        return stack;
    };
    SubSummaryComponent.prototype.getMulti = function (id) {
        var isMulti = false;
        if (!id)
            return false;
        if (this.stackCardBasic.find(function (x) { return x.Id == id; })) {
            if (this.stackCardBasic.find(function (x) { return x.Id == id; }).Type == 'multi') {
                isMulti = true;
            }
        }
        return isMulti;
    };
    SubSummaryComponent.prototype.toggleStack = function (groupId, event) {
        if (this.stackCardBasic.find(function (x) { return x.GroupId == groupId; })) {
            this.stackCardBasic.filter(function (x) { return x.GroupId == groupId; }).forEach(function (card) {
                var cardNo = card.StackNo;
                var cardToggle = card.ToggleNo;
                card.ToggleNo = cardNo;
                card.StackNo = cardToggle;
            });
            this.stackCardBasic.find(function (x) { return x.GroupId == groupId; }).ShowCards = !this.stackCardBasic.find(function (x) { return x.GroupId == groupId; }).ShowCards;
        }
        event.stopPropagation();
    };
    SubSummaryComponent.prototype.openCombobox = function (isFilter) {
        if (isFilter === void 0) { isFilter = false; }
        if (this.isSummaryPopup || isFilter) {
            // if (isFilter) this.virtualScroller.invalidateAllCachedMeasurements();
            document.querySelectorAll("body").item(0).style.position = "relative";
        }
    };
    SubSummaryComponent.prototype.closeCombobox = function (isFilter) {
        if (isFilter === void 0) { isFilter = false; }
        if (this.isSummaryPopup || isFilter) {
            document.querySelectorAll("body").item(0).style.position = "initial";
        }
    };
    SubSummaryComponent.prototype.getShowCards = function (id) {
        if (!this.stackCardBasic.find(function (x) { return x.Id == id; }))
            return false;
        return this.stackCardBasic.find(function (x) { return x.Id == id; }).ShowCards;
    };
    SubSummaryComponent.prototype.getStackItemsCount = function (groupId) {
        if (this.stackCardBasic.filter(function (x) { return x.GroupId == groupId; }).length < 2) {
            return "";
        }
        else {
            var itemCount = this.stackCardBasic.filter(function (x) { return x.GroupId == groupId; }).length - 1;
            if (itemCount == 1) {
                return itemCount + " more item";
            }
            else {
                return itemCount + " more items";
            }
        }
    };
    SubSummaryComponent.prototype.getVisibleColumns = function () {
        var _this = this;
        this.visibleColumns = this.summary.Columns.filter(function (x) { return !x.PropertyIsHidden; }).sort(function (a, b) {
            if (a.PropertyOrder > b.PropertyOrder) {
                return 1;
            }
            else if (a.PropertyOrder < b.PropertyOrder) {
                return -1;
            }
            else {
                return 0;
            }
        });
        this.visibleColumns.forEach(function (column) {
            if (column.AdditionalParameter == "lookup") {
                if (column.ColumnFilterString) {
                    var array = JSON.parse(column.ColumnFilterString);
                    column.ColumnFilterArray = [];
                    if (column.FilterValueSelection) {
                        if (array) {
                            array.forEach(function (element) {
                                column.ColumnFilterArray.push(column.FilterValueSelection.find(function (x) { return x.SelectionValue == element; }).SelectionDisplay);
                            });
                        }
                    }
                    // column.ColumnFilterArray = JSON.parse(column.ColumnFilterString);
                    if (!column.FilterValueSelection) {
                        _this.getFilterDropdownList(column.PropertyName);
                    }
                }
                else {
                    column.ColumnFilterString = null;
                }
            }
        });
        this.visibleColumnNames = this.visibleColumns.map(function (x) { return x.PropertyName; });
        if (this.summary.ShowCheckmark) {
            this.visibleColumnNames.unshift("#RowNumber");
        }
        // if (this.summary.ColumnHasSearch){
        //   this.visibleColumnNames.push("#Clear");
        // }
        // this.summaryData.forEach(data => {
        //   data["#Clear"] = "";
        // });
        if (this.visibleColumns.find(function (x) { return x.ColumnIsSorted; })) {
            this.activeSort = this.visibleColumns.find(function (x) { return x.ColumnIsSorted; }).PropertyName;
            this.activeSortDirection = this.visibleColumns.find(function (x) { return x.ColumnIsSorted; }).ColumnSortIsAsc ? 'asc' : 'desc';
        }
    };
    SubSummaryComponent.prototype.colTrackBy = function (index, item) { return item.PropertyName; };
    SubSummaryComponent.prototype.sortSummaryData = function (summaryData) {
        return summaryData.sort(function (a, b) {
            if (parseInt(a["#RowNumber"]) > parseInt(b["#RowNumber"])) {
                return 1;
            }
            else if (parseInt(a["#RowNumber"]) < parseInt(b["#RowNumber"])) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    SubSummaryComponent.prototype.sortSummaryFunctions = function () {
        this.summary.Functions = this.summary.Functions.sort(function (a, b) {
            if (a.ActionSequence > b.ActionSequence) {
                return 1;
            }
            else if (a.ActionSequence < b.ActionSequence) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    SubSummaryComponent.prototype.handleSummaryFunctions = function () {
        if (this.summary.Functions) {
            var summaryFunctions = this.summary.Functions.filter(function (x) { return x.ActionType != "ACTIONSAVE"; });
            if (summaryFunctions.length > 0) {
                if (this.isFromExpandSummary) {
                    summaryFunctions = summaryFunctions.filter(function (x) { return x.ActionType != "EXPAND"; });
                }
                this.sortSummaryFunctions();
                this.actions = summaryFunctions;
                if (summaryFunctions.length == 1) {
                    this.showSummaryMenu = true;
                    if (summaryFunctions[0].ActionSequence == 0) {
                        this.showSummaryMenu = false;
                    }
                }
                else {
                    this.showSummaryMenu = true;
                }
                this.showSummarySettings.emit(true);
            }
            else {
                this.showSummaryMenu = false;
                this.showSummarySettings.emit(false);
            }
        }
        else {
            this.showSummaryMenu = false;
            this.showSummarySettings.emit(false);
        }
    };
    SubSummaryComponent.prototype.handleActionSave = function () {
        var _this = this;
        if (this.summary.Functions) {
            this.summary.Functions.filter(function (x) { return x.ActionType == "ACTIONSAVE"; }).forEach(function (fn) {
                var action = _this.summary.Actions.find(function (x) { return x.ActionCommand == fn.ActionParameter; });
                if (action) {
                    _this.actionSaveDisplay = fn.ActionDisplay;
                    action.IsHidden = true;
                }
            });
        }
    };
    SubSummaryComponent.prototype.handleHeaderAndFooter = function () {
        var _this = this;
        if (this.summary.FooterText) {
            if (this.summary.FooterText.indexOf("{") > -1) {
                this.summary.FooterHasButton = true;
                var re = new RegExp(/{(.*?)}/); // get string inside curly bracket
                var reString = re.exec(this.summary.FooterText);
                if (reString) {
                    if (reString.length > 0) {
                        var displayValue = reString[1].split('|')[0];
                        this.footerButton = this.summary.Actions.find(function (x) { return x.ActionName == reString[1].split('|')[1]; });
                        if (this.footerButton) {
                            this.footerButton.IsHidden = true;
                            this.summary.FooterText = this.summary.FooterText.replace(re, "<span class='footer-button'>" + displayValue + "</span>");
                            setTimeout(function () {
                                if (_this.elRef.nativeElement.querySelector('.footer-button')) {
                                    if (_this.footerBtnInstance) {
                                        _this.footerBtnInstance();
                                    }
                                    _this.footerBtnInstance = _this.renderer.listen(_this.elRef.nativeElement.querySelector('.footer-button'), 'click', function () {
                                        _this.performAction('', _this.footerButton.ActionCommand, _this.footerButton);
                                    });
                                }
                            });
                        }
                    }
                }
            }
            else if (this.summary.FooterText.indexOf("=") > -1) {
                var re = new RegExp(/=([^\s]+)/g); // get string after equal sign, before whitespace
                var matches = this.summary.FooterText.match(/=([^\s]+)/g);
                if (matches) {
                    matches.forEach(function (match) {
                        var text = match;
                        var phrase = match.replace("=", "");
                        var total = 0;
                        var operator = "add";
                        var secColumnName;
                        var columnName = phrase.split('|')[0];
                        var formatString = phrase.split('|')[1];
                        if (columnName.split('*')[1]) {
                            secColumnName = columnName.split('*')[1];
                            columnName = columnName.split('*')[0];
                            operator = "multiply";
                        }
                        else if (columnName.split('-')[1]) {
                            secColumnName = columnName.split('-')[1];
                            columnName = columnName.split('-')[0];
                            operator = "substract";
                        }
                        else if (columnName.split('/')[1]) {
                            secColumnName = columnName.split('/')[1];
                            columnName = columnName.split('/')[0];
                            operator = "division";
                        }
                        total = _this.getTotalClientCalculation(columnName, secColumnName, operator, total);
                        if (formatString) {
                            _this.workspaceService.convertToDecimal(total.toString(), formatString).subscribe(function (result) {
                                _this.summary.FooterText = _this.summary.FooterText.replace(text, "<span class='client-calc' data-column='" + columnName
                                    + "' data-seccolumn='" + secColumnName + "' data-format='" + formatString + "' data-operator='" + operator + "'>" + result + "</span>");
                            });
                        }
                        else {
                            _this.summary.FooterText = _this.summary.FooterText.replace(text, "<span class='client-calc' data-column='" + columnName
                                + "' data-seccolumn='" + secColumnName + "' data-format='" + formatString + "' data-operator='" + operator + "'>" + total + "</span>");
                        }
                    });
                }
            }
        }
    };
    SubSummaryComponent.prototype.retrieveDataByCardProperty = function (cardProperty) {
        if (this.summary.CardLayoutProperties.find(function (x) { return x.CardProperty == cardProperty; }) != null) {
            return this.summary.CardLayoutProperties.find(function (x) { return x.CardProperty == cardProperty; }).PropertyName;
        }
    };
    SubSummaryComponent.prototype.retrieveColumnTypeByCardProperty = function (cardProperty) {
        if (this.summary.CardLayoutProperties.find(function (x) { return x.CardProperty == cardProperty; }) != null) {
            return this.summary.CardLayoutProperties.find(function (x) { return x.CardProperty == cardProperty; }).PropertyColumnType;
        }
    };
    SubSummaryComponent.prototype.retrieveColParamByCardProperty = function (cardProperty) {
        if (this.summary.CardLayoutProperties.find(function (x) { return x.CardProperty == cardProperty; }) != null) {
            return this.summary.CardLayoutProperties.find(function (x) { return x.CardProperty == cardProperty; }).ColumnParameter;
        }
    };
    SubSummaryComponent.prototype.retrieveFormatByCardProperty = function (cardProperty) {
        if (this.summary.CardLayoutProperties.find(function (x) { return x.CardProperty == cardProperty; }) != null) {
            return this.summary.CardLayoutProperties.find(function (x) { return x.CardProperty == cardProperty; }).PropertyFormat;
        }
    };
    SubSummaryComponent.prototype.getLink = function (url) {
        var newUrl = "//" + url;
        return this.sanitizer.bypassSecurityTrustUrl(newUrl);
    };
    SubSummaryComponent.prototype.getIndicatorColor = function (data) {
        this.indicatorColor = this.loaderConfig.primaryColour;
        if (this.summaryLayout == "CARDSTANDARDSTATUS") {
            if (data == "GOOD") {
                this.indicatorColor = "#64A338";
            }
            else if (data == "BAD") {
                this.indicatorColor = "#f89406";
            }
        }
        else {
            if (data == 0) {
                this.indicatorColor = "#f89406";
            }
        }
        return this.indicatorColor;
    };
    SubSummaryComponent.prototype.openDetail = function (docInstanceId) {
        var _this = this;
        if (!this.isBusy) {
            this.isBusy = true;
            this.animate = false;
            this.summaryService.selectItem(this.componentId, docInstanceId).subscribe(function (result) {
                _this.handleWorkflowReturn(result);
                _this.isBusy = false;
                _this.animate = true;
            });
        }
    };
    SubSummaryComponent.prototype.setCurrentImage = function (image) {
        this.currentImage = image;
    };
    SubSummaryComponent.prototype.createImageFromBlob = function (docId, imageId, image, list) {
        var _this = this;
        var reader = new FileReader();
        reader.addEventListener("load", function () {
            _this.summary.CardImageList.push({
                DocumentId: docId,
                ImageId: imageId,
                Blob: reader.result
            });
        }, false);
        if (image) {
            reader.readAsDataURL(image);
        }
    };
    SubSummaryComponent.prototype.getFirstImage = function (id) {
        if (this.summary.CardImageList != null) {
            if (this.summary.CardImageList.find(function (x) { return x.DocumentId == id; }) != null) {
                if (this.summary.CardImageList.find(function (x) { return x.DocumentId == id; }).Blob) {
                    return this.summary.CardImageList.find(function (x) { return x.DocumentId == id; }).Blob;
                }
                else {
                    return null;
                }
            }
        }
    };
    SubSummaryComponent.prototype.setDisplayedImage = function () {
    };
    SubSummaryComponent.prototype.getCardImage = function (id) {
        var array = [];
        if (this.summary.CardImageList != null) {
            if (this.summary.CardImageList.find(function (x) { return x.DocumentId == id; }) != null) {
                this.summary.CardImageList.filter(function (x) { return x.DocumentId == id; }).forEach(function (element) {
                    array.push(element.Blob);
                });
                if (!this.currentImage) {
                    if (array.length > 0) {
                        this.currentImage = array[0];
                    }
                }
            }
        }
        return array;
    };
    SubSummaryComponent.prototype.getAllImage = function () {
        var _this = this;
        if (this.imageObject) {
            if (this.imageId.length > 0) {
                this.isImageLoad = true;
                this.promiseImage(this.imageId).then(function (chunk) {
                    _this.currentCardImage = chunk;
                    _this.summary.CardImageList = chunk;
                });
            }
        }
    };
    SubSummaryComponent.prototype.promiseImage = function (imageIds) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var list = [];
            _this.summaryService.getAllImage(_this.imageId).subscribe(function (results) {
                var index = 0;
                var _loop_2 = function (result) {
                    result = new Blob([result], { type: 'image/jpg' });
                    var docId = _this.imageObject.find(function (x) { return x.imageId == _this.imageId[index]; }).docId;
                    var reader = new FileReader();
                    reader.addEventListener("load", function () {
                        list.push({
                            DocumentId: docId,
                            ImageId: _this.imageId[index],
                            Blob: reader.result
                        });
                    }, false);
                    if (result) {
                        reader.readAsDataURL(result);
                    }
                    index++;
                };
                for (var _i = 0, results_2 = results; _i < results_2.length; _i++) {
                    var result = results_2[_i];
                    _loop_2(result);
                }
                setTimeout(function () {
                    _this.isImageLoad = false;
                }, 100);
            });
            resolve(list);
        });
    };
    SubSummaryComponent.prototype.performAction = function (selectedItemId, actionCommand, action, customParam) {
        var _this = this;
        if (customParam === void 0) { customParam = null; }
        this.isBusy = true;
        this.animate = false;
        if (selectedItemId) {
            actionCommand = actionCommand.split(':')[1].replace("}", "");
            this.summaryService.summaryItem(this.componentId, selectedItemId, "", actionCommand).subscribe(function (result) {
                _this.handleWorkflowReturn(result);
            });
        }
        else {
            var param;
            if (this.summary.SelectionType == 'SINGLE' || this.summary.SelectionType == 'MULTI') {
                param = [];
                param = this.markList;
                if (this.summaryLayout == "TABLE") {
                    if (this.parentArray.length > 0) {
                        this.allSelectedIds.forEach(function (id) {
                            if (_this.parentArray.findIndex(function (x) { return x.id == id; }) < 0) {
                                var arr = [];
                                arr.push({ name: _this.idColumn, value: id });
                                _this.parentArray.push({ id: id, value: arr });
                            }
                        });
                    }
                    else {
                        this.allSelectedIds.forEach(function (id) {
                            var arr = [];
                            arr.push({ name: _this.idColumn, value: id });
                            _this.parentArray.push({ id: id, value: arr });
                        });
                    }
                    param = this.parentArray.map(function (a) { return a.value; }); // list of list of mbsparameterobjects
                }
            }
            else if (this.summary.CellSelectionType == 'SINGLE') {
                param = [];
                var arr = [];
                var newCellsSelected = [];
                this.cellsSelected.forEach(function (cell) {
                    newCellsSelected.push(cell.value);
                });
                arr.push({ name: this.cellsSelected[0].name, value: JSON.stringify(newCellsSelected) });
                param.push(arr);
            }
            else {
                param = "";
            }
            if (customParam)
                param = customParam;
            if (action) {
                this.isBusy = false;
                this.handlePrompt(action, param);
            }
            else {
                this.isBusy = true;
                this.summaryAction(actionCommand, param);
            }
        }
    };
    SubSummaryComponent.prototype.expandSummary = function (row, parameter) {
        var _this = this;
        var param = parameter.replace('{', '').replace('}', '');
        var cleanParam = param.split(this.separator);
        this.isExpandSummary = true;
        var dataColumn = this.summary.Columns.find(function (x) { return x.ViewColumnType == "DATA"; });
        var docId = "";
        if (dataColumn) {
            if (row[dataColumn.PropertyName]) {
                docId = row[dataColumn.PropertyName];
            }
        }
        if (row['summaryBreakdown']) {
            row['summaryBreakdownExpand'] = !row['summaryBreakdownExpand'];
        }
        else {
            row['isExpanding'] = true;
            this.isBusy = true;
            this.animate = false;
            this.summaryService.getSummaryBreakdownFromSummary(row[this.idColumn], cleanParam[1], cleanParam[2], docId).subscribe(function (result) {
                if (result) {
                    row['summaryBreakdown'] = result;
                }
                row['summaryBreakdownExpand'] = true;
                row['isExpanding'] = false;
                _this.isBusy = false;
                _this.animate = true;
            }, function (error) {
                row['isExpanding'] = true;
                _this.isBusy = false;
                _this.animate = true;
            });
        }
    };
    SubSummaryComponent.prototype.performRowAction = function (selectedItemId, command) {
        var _this = this;
        if (command.split(':')[1]) {
            var actionCommand = command.split(':')[1].replace("}", "");
            if (this.summary.RowActions.filter(function (x) { return x.ActionCommand == actionCommand; }).length > 0) {
                var action = this.summary.RowActions.find(function (x) { return x.ActionCommand == actionCommand; });
                if (action.TriggersPrompt) {
                    switch (action.PromptType) {
                        case "Yes|No":
                            this.summaryService.getConfirmationMessage(this.componentId, selectedItemId, action.ActionCommand).subscribe(function (result) {
                                if (result) {
                                    _this.confirmationService.confirm("Confirmation", result, ["CANCEL", "OK"])
                                        .subscribe(function (respond) {
                                        if (respond.answer == "OK") {
                                            _this.isBusy = true;
                                            _this.animate = false;
                                            _this.summaryItemAction(selectedItemId, action.ActionCommand);
                                        }
                                        else {
                                            _this.isBusy = false;
                                        }
                                    });
                                }
                            });
                            break;
                        case "TypeToConfirm":
                            this.confirmationService.confirm(action.PromptMessage.split('|')[0], "", ["CANCEL", "OK"], true, action.PromptMessage.split('|')[1], false, action.PromptMessage.split('|')[2])
                                .subscribe(function (respond) {
                                if (respond.answer == "OK") {
                                    _this.isBusy = true;
                                    _this.animate = false;
                                    _this.summaryItemAction(selectedItemId, action.ActionCommand);
                                }
                                else {
                                    _this.isBusy = false;
                                }
                            });
                            break;
                    }
                }
                else {
                    this.isBusy = true;
                    this.animate = false;
                    this.summaryItemAction(selectedItemId, action.ActionCommand);
                }
            }
        }
    };
    SubSummaryComponent.prototype.summaryAction = function (actionCommand, param) {
        var _this = this;
        this.isBusy = true;
        this.animate = false;
        this.summaryService.summaryAction(this.componentId, param, actionCommand).subscribe(function (result) {
            _this.handleWorkflowReturn(result);
        }, function (error) {
            _this.animate = true;
            _this.isBusy = false;
        });
    };
    SubSummaryComponent.prototype.summaryItemAction = function (selectedItemId, actionCommand) {
        var _this = this;
        this.showNoLoader = true;
        this.summaryService.summaryItem(this.componentId, selectedItemId, "", actionCommand).subscribe(function (result) {
            _this.handleWorkflowReturn(result);
        });
    };
    SubSummaryComponent.prototype.handlePrompt = function (action, param) {
        var _this = this;
        if (action.TriggersPrompt) {
            switch (action.PromptType) {
                case "Yes|No":
                    this.confirmationService.confirm("Confirmation", action.PromptMessage, ["CANCEL", "OK"])
                        .subscribe(function (respond) {
                        if (respond.answer == "OK") {
                            _this.summaryAction(action.ActionCommand, param);
                        }
                    });
                    break;
                case "TypeToConfirm":
                    this.confirmationService.confirm(action.PromptMessage.split('|')[0], "", ["CANCEL", "OK"], true, action.PromptMessage.split('|')[1], false, action.PromptMessage.split('|')[2])
                        .subscribe(function (respond) {
                        if (respond.answer == "OK") {
                            _this.summaryAction(action.ActionCommand, param);
                        }
                    });
                    break;
            }
        }
        else {
            this.summaryAction(action.ActionCommand, param);
        }
    };
    SubSummaryComponent.prototype.actionOnCard = function (qty, selectedItemId, actionName, departmentId, currentPage) {
        var _this = this;
        if (departmentId === void 0) { departmentId = ""; }
        this.isBusy = true;
        var param = [];
        param.push({ name: 'input_quantity', value: qty });
        param.push({ name: 'selectedItemId', value: selectedItemId });
        param.push({ name: 'departmentId', value: departmentId });
        this.animate = false;
        this.summaryService.summaryItem(this.componentId, selectedItemId, param, actionName).subscribe(function (result) {
            _this.handleWorkflowReturnCurrentPage(result, false, currentPage);
        });
    };
    SubSummaryComponent.prototype.actionOnCardWithoutParam = function (selectedItemId, actionName) {
        var _this = this;
        this.isCardBusy = true;
        this.summaryService.summaryItem(this.componentId, selectedItemId, "", actionName).subscribe(function (result) {
            _this.handleWorkflowReturn(result);
            _this.isCardBusy = false;
        }, function (error) {
            _this.isCardBusy = false;
        });
    };
    SubSummaryComponent.prototype.selectCell = function (column, row) {
        var _this = this;
        // need to change the checking once the indicator for cell selectable is there 
        // ie: set selected value for all data on initial load, avoid additional checking here
        // get all the selected cells by checking each summary data and find the selected column name to find its data
        if (this.summary.CellSelectionType == "SINGLE" || this.summary.CellSelectionType == "MULTI") {
            var value = this.summaryData.find(function (x) { return x["#RowNumber"] == row["#RowNumber"]; });
            if (this.cellsSelected.findIndex(function (z) { return z.name == column.PropertyName; }) == -1) {
                this.cellsSelected = [];
                this.summaryData.forEach(function (data) {
                    data['selected'] = [];
                });
            }
            if (value) {
                if (value['selected']) {
                    if (value['selected'].length > 0) {
                        if (value['selected'].findIndex(function (y) { return y == column.PropertyName; }) > -1) {
                            var index = value['selected'].indexOf(column.PropertyName);
                            if (index !== -1)
                                value['selected'].splice(index, 1);
                        }
                        else {
                            value['selected'].push(column.PropertyName);
                        }
                    }
                    else {
                        value['selected'] = [column.PropertyName];
                    }
                }
                else {
                    value['selected'] = [column.PropertyName];
                }
                // unselect
                var exists = this.cellsSelected.findIndex(function (z) { return z.index == row["#RowNumber"]; });
                if (exists > -1) {
                    this.cellsSelected.splice(exists, 1);
                }
                else {
                    var selected = { "index": row["#RowNumber"], "name": column.PropertyName, "value": row[column.PropertyName] };
                    this.cellsSelected.push(selected);
                }
                this.summary.Columns.forEach(function (column) {
                    column.CellsSelected = 0;
                    _this.summaryData.forEach(function (data) {
                        var index = -1;
                        if (data['selected']) {
                            index = data['selected'].indexOf(column.PropertyName);
                        }
                        if (index > -1)
                            column.CellsSelected++;
                    });
                });
            }
        }
        this.summary.Actions.forEach(function (action) {
            _this.checkButtonDisabled(action);
        });
    };
    SubSummaryComponent.prototype.removeDuplicatesBy = function (comparator, array) {
        var length = array.length;
        var unique = [];
        for (var i = 0; i < length; i++) {
            var element = array[i];
            var isUnique = true;
            for (var j = 0; j < i; j++) {
                if (comparator(element, array[j])) {
                    isUnique = false;
                    break;
                }
            }
            if (isUnique)
                unique.push(element);
        }
        return unique;
    };
    SubSummaryComponent.prototype.getBoolean = function (any) {
        var bool;
        if (any) {
            if (any == true || any == 'True' || any == 'true') {
                bool = true;
            }
            else {
                bool = false;
            }
        }
        else {
            bool = false;
        }
        return bool;
    };
    SubSummaryComponent.prototype.isFloat = function (value) {
        return /^(\d{1,})(,\d{1,})*(\.\d{1,})?$/.test(value);
    };
    SubSummaryComponent.prototype.saveLineChange = function (data, column, qty, actionName, departmentId) {
        var _this = this;
        if (departmentId === void 0) { departmentId = ""; }
        var cleanedValue = qty;
        if (!Array.isArray(qty)) {
            if (this.isFloat(qty.replace(/,/g, ""))) {
                cleanedValue = qty.replace(/,/g, "");
            }
        }
        var array = [];
        array.push({ name: 'input_quantity', value: cleanedValue });
        array.push({ name: 'selectedItemId', value: data[this.idColumn] });
        array.push({ name: 'departmentId', value: departmentId });
        var index = this.rowsToUpdate.findIndex(function (x) { return x.id == data[_this.idColumn] + column.PropertyName; });
        if (index > -1) {
            this.rowsToUpdate.splice(index, 1);
        }
        var param = [
            { name: "id", value: data[this.idColumn] },
            { name: "action", value: actionName },
            { name: "param", value: JSON.stringify(array) }
        ];
        this.rowsToUpdate.push({
            id: data[this.idColumn] + column.PropertyName,
            value: param
        });
    };
    SubSummaryComponent.prototype.handleWorkflowReturn = function (result, noEmit) {
        if (noEmit === void 0) { noEmit = false; }
        var command = JSON.parse(result);
        this.workflowReturnService.handleWorkflowReturn(command, false);
        if (command.ReturnType != 10 && (command.RefreshType == "self" || command.RefreshType == "none" || !command.RefreshType)) {
            this.animate = true;
            this.isBusy = false;
        }
        //web content
        if (command.ReturnType == 13) {
            this.emitSelectedItem(command.Arguments[0]);
        }
        if (!noEmit) {
            switch (command.ReturnType) {
                case 3:
                    this.emitSelectedItem(command.Arguments[0]);
                    this.selectedItemId = command.Arguments[0];
                    break;
                case 4://message
                    if (command.Arguments[2]) {
                        this.emitSelectedItem(command.Arguments[0]);
                        this.selectedItemId = command.Arguments[0];
                    }
                    break;
            }
        }
        switch (command.RefreshType) {
            case "self":
                this.emitSelectedId = false;
                this.refreshCard();
                break;
            case "parent":
                this.isBusy = true;
                this.refreshCard();
                this.getEPICParent(false, command.ReturnType);
                break;
            case "all":
                this.refreshCard();
                this.getEPICParent(true, command.ReturnType);
                break;
        }
    };
    SubSummaryComponent.prototype.handleWorkflowReturnCurrentPage = function (result, noEmit, currentPage) {
        if (noEmit === void 0) { noEmit = false; }
        var command = JSON.parse(result);
        this.workflowReturnService.handleWorkflowReturn(command, false);
        if (command.ReturnType != 10 && (command.RefreshType == "self" || command.RefreshType == "none" || !command.RefreshType)) {
            this.animate = true;
            this.isBusy = false;
        }
        //web content
        if (command.ReturnType == 13) {
            this.emitSelectedItem(command.Arguments[0]);
        }
        if (!noEmit) {
            switch (command.ReturnType) {
                case 3:
                    this.emitSelectedItem(command.Arguments[0]);
                    this.selectedItemId = command.Arguments[0];
                    break;
                case 4://message
                    if (command.Arguments[2]) {
                        this.emitSelectedItem(command.Arguments[0]);
                        this.selectedItemId = command.Arguments[0];
                    }
                    break;
            }
        }
        switch (command.RefreshType) {
            case "self":
                this.emitSelectedId = false;
                this.refreshCardCurrentPage(true, currentPage);
                break;
            case "parent":
                this.isBusy = true;
                this.refreshCardCurrentPage(true, currentPage);
                this.getEPICParent(false, command.ReturnType);
                break;
            case "all":
                this.refreshCardCurrentPage(true, currentPage);
                this.getEPICParent(true, command.ReturnType);
                break;
        }
    };
    SubSummaryComponent.prototype.getEPICParent = function (findAllParent, returnType) {
        var _this = this;
        if (findAllParent) {
            this.workspaceService.getAllParentsEPICId(this.componentId).subscribe(function (result) {
                _this.handlePopup(returnType);
                if (result) {
                    var array = JSON.parse(result);
                    array.forEach(function (id) {
                        _this.workspaceService.setParentId(id);
                    });
                }
            }, function (error) {
                _this.handlePopup(returnType);
            });
        }
        else {
            this.workspaceService.getParentEPICId(this.componentId).subscribe(function (result) {
                _this.workspaceService.setParentId(result);
                _this.handlePopup(returnType);
            }, function (error) {
                _this.handlePopup(returnType);
            });
        }
    };
    SubSummaryComponent.prototype.handlePopup = function (returnType) {
        if (returnType == 4) {
            this.hidePopup.emit(true);
        }
    };
    SubSummaryComponent.prototype.hidesAllModals = function () {
        for (var i = 1; i <= this.modalService.getModalsCount(); i++) {
            this.modalService.hide(i);
        }
        document.body.classList.remove('modal-open');
        this.sidePopupService.removePopup();
    };
    SubSummaryComponent.prototype.handleNavigateAndMessage = function (command, hasSession) {
        if (hasSession === void 0) { hasSession = false; }
        var path = [];
        var newArgs = command.Arguments.splice(2);
        newArgs.forEach(function (element) {
            path.push(element);
        });
        if (hasSession) {
            // close all popups
            for (var i = 1; i <= this.modalService.getModalsCount(); i++) {
                this.modalService.hide(i);
            }
            document.body.classList.remove("modal-open");
            this.router.navigate(path);
            this.headerService.setSelectedMenu('clearSelected');
            this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
        }
    };
    SubSummaryComponent.prototype.openDetailPopup = function (event, title) {
        var _this = this;
        var initialState = {
            componentId: event,
            title: title
        };
        var config = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-dialog-centered modal-detail',
            initialState: {
                componentId: event,
                title: title
            }
        };
        if (this.modalService.getModalsCount() > 0) {
            document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
        }
        this.modalService.onHide.subscribe(function (reason) {
            if (_this.modalService.getModalsCount() > 0) {
                document.querySelectorAll('.modal.fade').item(_this.modalService.getModalsCount() - 1).classList.add('show');
            }
        });
        this.modalRef = this.modalService.show(DetailPopupComponent, config);
    };
    SubSummaryComponent.prototype.downloadFile = function (blob, fileName) {
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(objectUrl);
    };
    SubSummaryComponent.prototype.toggleImageFav = function () {
        this.isFav = !this.isFav;
    };
    SubSummaryComponent.prototype.viewProductDetail = function (id) {
        var _this = this;
        if (this.parentType) {
            this.emitSelectedItem(id);
            this.selectedItemId = id;
        }
        else {
            this.selectedItemId = id;
            this.isBusy = true;
            this.animate = false;
            this.summaryService.selectItem(this.componentId, id).subscribe(function (result) {
                _this.handleWorkflowReturn(result);
                _this.isBusy = false;
                _this.animate = true;
            }, function (error) {
                _this.isBusy = false;
                _this.animate = true;
            });
        }
    };
    SubSummaryComponent.prototype.emitSelectedItem = function (result) {
        this.subSelectedId.emit(result);
        this.popupSelectedId.emit(result); //if the parent is popup
    };
    SubSummaryComponent.prototype.clientCalculation = function () {
        var _this = this;
        if (this.elRef.nativeElement.querySelectorAll('.client-calc').length > 0) {
            this.elRef.nativeElement.querySelectorAll('.client-calc').forEach(function (element) {
                var el = element;
                var columnName = el.dataset.column; // get from data attr
                var secColumnName = el.dataset.seccolumn;
                var formatString = el.dataset.format;
                var operator = el.dataset.operator;
                var total = 0;
                total = _this.getTotalClientCalculation(columnName, secColumnName, operator, total);
                if (formatString) {
                    if (total) {
                        _this.promiseConvertDecimal(total.toString(), formatString).then(function (result) {
                            el.innerHTML = result;
                        });
                    }
                }
                else {
                    el.innerHTML = total;
                }
            });
        }
    };
    SubSummaryComponent.prototype.promiseConvertDecimal = function (total, formatString) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.workspaceService.convertToDecimal(total.toString(), formatString).subscribe(function (result) {
                resolve(result);
            });
        });
    };
    SubSummaryComponent.prototype.getTotalClientCalculation = function (columnName, secColumnName, operator, total) {
        this.summaryData.forEach(function (element) {
            if (operator == "add") {
                var value = parseFloat(element[columnName].toString().replace(/,/g, ''));
                total = total + value;
            }
            else if (operator == "multiply") {
                var value = parseFloat(element[columnName].toString().toString().replace(/,/g, '')) * parseFloat(element[secColumnName].toString().replace(/,/g, ''));
                total = total + value;
            }
            else if (operator == "substract") {
                var value = parseFloat(element[columnName].toString().replace(/,/g, '')) - parseFloat(element[secColumnName].toString().replace(/,/g, ''));
                total = total + value;
            }
            else if (operator == "division") {
                var value = parseFloat(element[columnName].toString().replace(/,/g, '')) / parseFloat(element[secColumnName].toString().replace(/,/g, ''));
                total = total + value;
            }
        });
        return total;
    };
    SubSummaryComponent.prototype.formatData = function (summaryData, prop, input) {
        var _this = this;
        input.errorState = true;
        var propFormat = this.retrieveFormatByCardProperty(prop);
        if (propFormat) {
            var format = propFormat.split(':')[1] ? propFormat.split(':')[1] : propFormat;
            this.workspaceService.convertToDecimal(input.value, format).subscribe(function (result) {
                if (result == "0" && result != summaryData[_this.retrieveDataByCardProperty(prop)]) {
                    // summaryData['error'] = true;
                    // set back to its original value
                    var originalValue;
                    if (summaryData["prev" + _this.retrieveDataByCardProperty(prop)]) {
                        originalValue = summaryData["prev" + _this.retrieveDataByCardProperty(prop)];
                    }
                    else {
                        originalValue = _this.cloneSummaryData.find(function (x) { return x[_this.idColumn] == summaryData[_this.idColumn]; })[_this.retrieveDataByCardProperty(prop)];
                    }
                    summaryData[_this.retrieveDataByCardProperty(prop)] = originalValue;
                    _this.onCardChangeData(summaryData[_this.idColumn], prop, originalValue);
                }
                else {
                    // summaryData['error'] = false;
                    summaryData["prev" + _this.retrieveDataByCardProperty(prop)] = result;
                    summaryData[_this.retrieveDataByCardProperty(prop)] = result;
                    _this.onCardChangeData(summaryData[_this.idColumn], prop, result);
                }
            });
        }
    };
    SubSummaryComponent.prototype.onCardChangeData = function (id, cardProperty, value) {
        var obj = { id: id, cardProperty: cardProperty, value: value };
        this.rowDataChanged.next(obj);
        var actionCommand;
        var columnName;
        if (this.summary.CardLayoutProperties.find(function (x) { return x.CardProperty == cardProperty; }) != null) {
            actionCommand = this.summary.CardLayoutProperties.find(function (x) { return x.CardProperty == cardProperty; }).ColumnParameter;
            columnName = this.summary.CardLayoutProperties.find(function (x) { return x.CardProperty == cardProperty; }).PropertyName;
        }
        if (actionCommand && columnName) {
            var index = this.rowsToUpdate.findIndex(function (x) { return x.id == id + columnName; });
            if (index > -1) {
                this.rowsToUpdate.splice(index, 1);
            }
            // if (this.cloneSummaryData.find(x => x[this.idColumn] == id)[this.retrieveDataByCardProperty(cardProperty)] != value){ // not the same as original value
            var cleanedValue = value;
            if (this.isFloat(value.replace(/,/g, ""))) {
                cleanedValue = value.replace(/,/g, "");
            }
            var array = [];
            array.push({ name: 'input_quantity', value: cleanedValue });
            var param = [
                { name: "id", value: id },
                { name: "action", value: actionCommand },
                { name: "param", value: JSON.stringify(array) }
            ];
            this.rowsToUpdate.push({
                id: id + columnName,
                value: param
            });
            // }
        }
    };
    SubSummaryComponent.prototype.onChangeData = function (row, column, value, checkboxValue) {
        var _this = this;
        if (column.ViewColumnType == "CHECKBOX") {
            // cannot check selected value from lookup as lookup for summary column is the same for all row
            var array = JSON.parse(row[column.PropertyName]);
            if (array.length > 0) {
                var index = array.findIndex(function (x) { return x == checkboxValue; });
                if (index > -1) {
                    array.splice(index, 1);
                }
            }
            else {
                var newValue = checkboxValue;
                if (!isNaN(+checkboxValue)) {
                    newValue = +checkboxValue;
                }
                array.push(newValue);
            }
            row[column.PropertyName] = JSON.stringify(array);
            this.handleChangedValue(row, column, row[column.PropertyName]);
        }
        else {
            this.handleChangedValue(row, column, value);
        }
        // if (column.ViewColumnType == 'MULTICOMBOBOX'){
        //   this.virtualScroller.invalidateAllCachedMeasurements();
        // }
        if (this.parentArray.findIndex(function (x) { return x.id == row[_this.idColumn]; }) != -1) {
            this.parentArray.find(function (x) { return x.id == row[_this.idColumn]; }).value.forEach(function (obj) {
                if (obj.name == column.PropertyName) {
                    if (column.ViewColumnType == 'COMBOBOX') {
                        obj.value = row[column.PropertyName];
                    }
                    else {
                        obj.value = JSON.stringify(row[column.PropertyName]);
                    }
                }
            });
        }
    };
    SubSummaryComponent.prototype.handleChangedValue = function (row, column, value) {
        // this.showSaveIcon = row[this.idColumn];
        // this.showSaveIconLabel = column.PropertyName;
        var _this = this;
        var param;
        param = { property: column.PropertyName, value: row[column.PropertyName] };
        var changeRowValue = false;
        var actionName = (column.ViewColumnType == "COMBOBOX" || column.ViewColumnType == "MULTICOMBOBOX" || column.ViewColumnType == "CHECKBOX") ? column.AdditionalParameter.split('|')[1] : column.AdditionalParameter;
        if (actionName) {
            if (this.cloneSummaryData.find(function (x) { return x[_this.idColumn] == row[_this.idColumn]; })[column.PropertyName] != row[column.PropertyName]) {
                this.saveLineChange(row, column, value, actionName, row['DepartmentId']);
            }
            else {
                var index = this.rowsToUpdate.findIndex(function (x) { return x.id == row[_this.idColumn] + column.PropertyName; });
                if (index > -1) {
                    this.rowsToUpdate.splice(index, 1);
                }
            }
        }
        else {
            changeRowValue = true;
        }
        if (changeRowValue) {
            this.summaryService.changeRowValue(this.componentId, row[this.idColumn], param).subscribe(function (result) {
                //update;
            });
        }
    };
    SubSummaryComponent.prototype.calculate = function (summaryData, prop, value, btn) {
        var _this = this;
        var formula = summaryData[this.retrieveDataByCardProperty('formula')];
        var data = summaryData[this.retrieveDataByCardProperty(prop)];
        var operator = summaryData[this.retrieveDataByCardProperty(btn)];
        if (formula !== null) {
            var matches = formula.match(/{(.*?)}/g); // get string with curly braces
            matches.forEach(function (match) {
                var dataValue = summaryData[match.replace('{', '').replace('}', '')];
                formula = formula.replace(match, dataValue);
            });
            var expression = "" + data + operator + formula.replace("=", "");
            var total = eval(expression.replace(/,/g, ""));
            if (eval(total)) {
                var propFormat = this.retrieveFormatByCardProperty(prop);
                if (propFormat) {
                    var format = propFormat.split(':')[1] ? propFormat.split(':')[1] : propFormat;
                    this.workspaceService.convertToDecimal(total, format).subscribe(function (result) {
                        summaryData[_this.retrieveDataByCardProperty(prop)] = result;
                        _this.onCardChangeData(summaryData[_this.idColumn], prop, result);
                    });
                }
                else {
                    summaryData[this.retrieveDataByCardProperty(prop)] = total;
                    this.onCardChangeData(summaryData[this.idColumn], prop, total);
                }
            }
        }
    };
    SubSummaryComponent.prototype.saveAllChanges = function () {
        var _this = this;
        this.emitSelectedId = false;
        this.isBusy = true;
        this.animate = false;
        this.showNoLoader = true;
        this.summaryService.actionOnAllItem(this.componentId, this.rowsToUpdate.map(function (x) { return x.value; })).subscribe(function (result) {
            _this.rowsToUpdate = [];
            if (_this.summary.Functions) {
                if (_this.summary.Functions.filter(function (x) { return x.ActionType == "ACTIONSAVE"; }).length > 0) {
                    var parsed = JSON.parse(result);
                    if (parsed.ReturnType == 1 && parsed.Arguments[0] != "Info") {
                        _this.handleWorkflowReturn(result);
                    }
                    else {
                        _this.summary.Functions.filter(function (x) { return x.ActionType == "ACTIONSAVE"; }).forEach(function (element) {
                            var action = _this.summary.Actions.find(function (x) { return x.ActionCommand == element.ActionParameter; });
                            var param = [];
                            param.push({ name: _this.idColumn, value: _this.summaryData[0][_this.idColumn] });
                            var parent = [];
                            parent.push(param);
                            _this.performAction('', action.ActionCommand, action, parent);
                        });
                    }
                }
                else {
                    _this.handleWorkflowReturn(result);
                }
            }
            else {
                _this.handleWorkflowReturn(result);
            }
        }, function (error) {
            _this.animate = true;
            _this.isBusy = false;
        });
    };
    // onClickCombobox(param: string, rowId: any){
    //   if (this.currentSelectedLookupId != rowId){
    //     this.summaryService.getSummaryDropdownList(this.componentId, rowId, param.split('|')[0]).subscribe(result => {
    //       var valueSelection:ValueSelection[] = JSON.parse(result);
    //       this.dropdownList[rowId] = valueSelection;
    //     });
    //     this.currentSelectedLookupId = rowId;
    //   }
    // }
    SubSummaryComponent.prototype.getFilterDropdownList = function (propertyName) {
        var _this = this;
        if (!this.visibleColumns.find(function (x) { return x.PropertyName == propertyName; }).FilterValueSelection) {
            this.summaryService.getSummaryFilterDropdownList(this.componentId, propertyName).subscribe(function (result) {
                var lookup = JSON.parse(result);
                if (result) {
                    lookup = _this.sortSummaryFilter(lookup);
                }
                _this.visibleColumns.find(function (x) { return x.PropertyName == propertyName; }).FilterValueSelection = lookup;
                var array = JSON.parse(_this.visibleColumns.find(function (x) { return x.PropertyName == propertyName; }).ColumnFilterString);
                _this.visibleColumns.find(function (x) { return x.PropertyName == propertyName; }).ColumnFilterArray = [];
                if (_this.visibleColumns.find(function (x) { return x.PropertyName == propertyName; }).FilterValueSelection) {
                    if (array) {
                        array.forEach(function (element) {
                            _this.visibleColumns.find(function (x) { return x.PropertyName == propertyName; }).ColumnFilterArray.
                                push(_this.visibleColumns.find(function (x) { return x.PropertyName == propertyName; }).FilterValueSelection.find(function (x) { return x.SelectionDisplay == element; }).SelectionValue);
                        });
                    }
                }
            });
        }
    };
    SubSummaryComponent.prototype.sortSummaryFilter = function (summryFilter) {
        return summryFilter.sort(function (a, b) {
            if (a.SelectionDisplay > b.SelectionDisplay) {
                return 1;
            }
            else if (a.SelectionDisplay < b.SelectionDisplay) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    SubSummaryComponent.prototype.searchHierarchy = function (filterText) {
        var _this = this;
        var cleanedData = this.summary.Data.filter(function (x) { return x[_this.retrieveDataByCardProperty('prop2')] !== null; });
        var filteredItems = cleanedData.filter(function (x) { return x[_this.retrieveDataByCardProperty('prop2')].toLowerCase().indexOf(filterText.toLowerCase()) > -1; });
        this.buildTree(filteredItems, true);
    };
    SubSummaryComponent.prototype.buildTree = function (data, isFilter) {
        var _this = this;
        if (isFilter === void 0) { isFilter = false; }
        var nodes = [];
        this.treeNodes = [];
        data.forEach(function (element) {
            nodes.push({
                id: element[_this.retrieveDataByCardProperty('ID')],
                title: element[_this.retrieveDataByCardProperty('prop2')],
                isSelected: false,
                parent: element[_this.retrieveDataByCardProperty('parentId')]
            });
        });
        if (data.filter(function (x) { return x[_this.retrieveDataByCardProperty('parentId')] == "00000000-0000-0000-0000-000000000000"; }).length > 0) {
            data.forEach(function (element) {
                if (element[_this.retrieveDataByCardProperty('parentId')] == "00000000-0000-0000-0000-000000000000") {
                    var tree = _this.getNestedChildren(nodes, element[_this.retrieveDataByCardProperty('ID')]);
                    _this.treeNodes.push({
                        id: element[_this.retrieveDataByCardProperty('ID')],
                        title: element[_this.retrieveDataByCardProperty('prop2')] ? element[_this.retrieveDataByCardProperty('prop2')] : 'Empty',
                        isSelected: false,
                        children: tree
                    });
                }
            });
        }
        else {
            // need to recursively find the parent
            this.treeNodes = nodes;
            // need idea
        }
        if (this.selectedItemId) {
            if (this.treeNodes.find(function (x) { return x.id == _this.selectedItemId; })) {
                this.treeNodes.find(function (x) { return x.id == _this.selectedItemId; }).isSelected = true;
            }
        }
        this.treeControl.dataNodes = this.treeNodes;
        this.treeDataSource.data = this.treeNodes;
    };
    SubSummaryComponent.prototype.keyupNumber = function (inputNumber, maxLimit) {
        inputNumber.value = inputNumber.value.replace(/[^\d]/, '');
        if (inputNumber.value == 0)
            inputNumber.value = '';
    };
    SubSummaryComponent.prototype.indexChange = function (event) {
        var swiper = this.directiveRef.swiper();
        if (this.directiveRef && !this.indexSet) {
            this.indexSet = true;
            this.directiveRef.setIndex(0);
        }
    };
    SubSummaryComponent.prototype.addNewRemarkForDocument = function (txtControl) {
        var _this = this;
        if (txtControl.value) {
            this.isBusy = true;
            this.animate = false;
            this.summaryService.addNewRemark(this.componentId, txtControl.value).subscribe(function (result) {
                if (result == "1") {
                    txtControl.value = "";
                    _this.refreshCard();
                }
                else {
                    _this.animate = true;
                    _this.isBusy = false;
                }
            }, function (error) {
                _this.animate = true;
                _this.isBusy = false;
            });
        }
    };
    SubSummaryComponent.prototype.checkButtonDisabled = function (action) {
        if (action.RequiresCellSelection) {
            if (this.cellsSelected.length > 0) {
                action.IsDisabled = false;
            }
            else {
                action.IsDisabled = true;
            }
        }
        else {
            if (action.RequiresSelection) {
                if (action.ExactOneSelection) {
                    if (this.markList.length == 1) {
                        action.IsDisabled = false;
                    }
                    else {
                        this.hasActionRequiresSelection = true;
                        action.IsDisabled = true;
                    }
                }
                else {
                    if (this.markList.length == 0) {
                        this.hasActionRequiresSelection = true;
                        action.IsDisabled = true;
                    }
                    else {
                        action.IsDisabled = false;
                    }
                }
            }
            else {
                action.IsDisabled = false;
            }
        }
    };
    SubSummaryComponent.prototype.storeIfSelectAll = function () {
        var _this = this;
        if (this.isSelectAll) {
            this.selectedRowCount = this.summary.TotalRows;
            this.markList = [];
            this.currentSummaryData.forEach(function (element) {
                _this.markList.push(element[_this.idColumn]);
            });
        }
        else {
            if (this.summary.TotalRows == this.markList.length) {
                if (this.summary.ShowCheckmark) {
                    this.selectedRowCount = this.summary.TotalRows;
                    this.isSelectAll = true;
                    this.summaryService.checkAllItems(this.componentId).subscribe(function (result) {
                        _this.allSelectedIds = JSON.parse(result);
                    });
                }
            }
        }
    };
    SubSummaryComponent.prototype.getTotalSelected = function () {
        if (this.isSelectAll) {
            if (this.isFilteredSummary) {
                return this.currentSummaryData.length;
            }
            else {
                return this.summary.TotalRows;
            }
        }
        else {
            return this.selectedRowCount;
        }
    };
    SubSummaryComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loaderConfig = this.themeSettingService.getTheme();
        var separators = [':', ';'];
        this.separator = new RegExp('[' + separators.join('') + ']', 'g');
        this.onGoing = true;
        this.nextPage.pipe(debounceTime(100)).subscribe(function (result) {
            if (!_this.isFetching && (_this.summary.AvailablePages > _this.summary.CurrentPage)) {
                _this.getNextSummary();
            }
        });
        this.sub3 = this.rowDataChanged.pipe(debounceTime(300)).subscribe(function (result) {
            _this.clientCalculation();
        });
    };
    SubSummaryComponent.prototype.ngOnChanges = function () {
        //this.refreshCard();
    };
    SubSummaryComponent.prototype.ngOnDestroy = function () {
        if (this.sub1)
            this.sub1.unsubscribe();
        if (this.sub2)
            this.sub2.unsubscribe();
        if (this.sub3)
            this.sub3.unsubscribe();
        if (this.sub4)
            this.sub4.unsubscribe();
        if (this.sub5)
            this.sub5.unsubscribe();
        if (this.sub6)
            this.sub6.unsubscribe();
        if (this.footerBtnInstance) {
            this.footerBtnInstance();
        }
    };
    SubSummaryComponent.prototype.ngAfterViewInit = function () {
    };
    SubSummaryComponent.prototype.onInitChartTable = function () {
        this.summaryService.setChartTable(true);
    };
    SubSummaryComponent.prototype.onTableInit = function () {
        if (this.tableContainer && this.isFromExpandSummary) {
            if (this.tableContainer.nativeElement.scrollHeight <= this.tableContainer.nativeElement.clientHeight) {
                // means no scrollbar
                if (this.summary.CurrentPage < this.summary.AvailablePages) {
                    // means theres more data, need to get more data
                    this.loopGetNextSummary();
                }
            }
        }
    };
    SubSummaryComponent.prototype.onScrolled = function (event) {
        if (this.summaryLayout == "SUMMARYSUPPLIER"
            || this.summaryLayout == "TABLE"
            || this.summaryLayout == "CARDIMAGEWIDE") {
            this.nextPage.next();
        }
    };
    SubSummaryComponent.prototype.tableScroll = function (e) {
        this.nextPageLoaded = false;
    };
    // onPlaybackChange(event){
    //   console.log(event);
    //   this.summaryData = this.summaryData.slice(0, event.value - 1);
    //   this.summaryData = [].concat(this.summaryData);
    //   this.chartService.setChartRefresh(true);
    // }
    SubSummaryComponent.prototype.onFileChange = function (event, row, column) {
        this.errorMessage = null;
        var fileList = event.target.files;
        if (fileList.length > 0) {
            this.uploadAttachment(fileList, 0, row, column);
        }
    };
    SubSummaryComponent.prototype.uploadAttachment = function (files, index, row, column, uploadSuccess) {
        var _this = this;
        if (uploadSuccess === void 0) { uploadSuccess = false; }
        if (this.allowedFormats.indexOf(files[index].name.split('.').pop().toLowerCase()) > -1 && files[index].name.indexOf(".") > -1) {
            var item = this.summaryData.find(function (x) { return x[_this.idColumn] == row[_this.idColumn]; });
            if (files[index].size / 1024 < this.maxFileSizeKb) {
                row["isUploading"] = true;
                //row["isUploadError"] = false;
                this.attachmentService.uploadAttachment(this.componentId, row[this.idColumn], encodeURIComponent(files[index].name), files[index], column.PropertyName).subscribe(function (result) {
                    if (result) {
                        index++;
                        if (files.length > index) {
                            _this.uploadAttachment(files, index, row[_this.idColumn], column, true);
                        }
                        else {
                            _this.getFileList(row, column);
                            row["isUploading"] = false;
                            //row["isUploadError"] = false;
                        }
                    }
                    else {
                        _this.getFileList(row, column);
                        row["isUploading"] = false;
                        //row["isUploadError"] = false;
                    }
                }, function (error) {
                    row["isUploading"] = false;
                    //row["isUploadError"] = true;
                    // this.fileControl.nativeElement.value = "";
                });
            }
            else {
                if (uploadSuccess)
                    this.getFileList(row, column);
                row["isUploading"] = false;
                //row["isUploadError"] = true;
                this.handleFileErrorMessage(FileErrorType.INVALID_SIZE);
            }
        }
        else {
            if (uploadSuccess)
                this.getFileList(row, column);
            row["isUploading"] = false;
            //row["isUploadError"] = true;
            this.handleFileErrorMessage(FileErrorType.INVALID_FORMAT);
        }
    };
    SubSummaryComponent.prototype.getFilesSettings = function () {
        var _this = this;
        this.attachmentService.getMaximumFileUploadSize().subscribe(function (result) {
            if (result) {
                _this.maxFileSizeKb = Number(result);
            }
        });
        this.attachmentService.getAllowedFileTypes().subscribe(function (result) {
            if (result) {
                _this.allowedFormats = result.split(',');
                _this.allowedFormatsString = _this.allowedFormats.join(' ');
                var array = [];
                _this.allowedFormats.forEach(function (element) {
                    var newEl = "." + element;
                    array.push(newEl);
                });
                _this.acceptFormatString = array.toString();
            }
        });
    };
    SubSummaryComponent.prototype.getFileList = function (row, column) {
        var _this = this;
        if (row[this.idColumn]) {
            this.attachmentService.getAttachmentList(this.componentId, row[this.idColumn], column.PropertyName).subscribe(function (result) {
                if (result) {
                    var fileList = JSON.parse(result);
                    // this.sortFileList();
                    fileList.forEach(function (file) {
                        _this.requestDownloadFile(file);
                    });
                    _this.pushFileList(row[_this.idColumn], column.PropertyName, fileList);
                }
                row["isUploading"] = false;
                //row["isUploadError"] = false;
            }, function (error) {
                row["isUploading"] = false;
                //row["isUploadError"] = true;
            });
        }
    };
    SubSummaryComponent.prototype.handleFileErrorMessage = function (fileErrorType) {
        switch (fileErrorType) {
            case FileErrorType.INVALID_FORMAT:
                this.errorMessage = "File format is not valid";
                break;
            case FileErrorType.INVALID_SIZE:
                // if (this.attachmentIsMultiple) {
                //   this.errorMessage = "Please make sure each file size does not exceed the maximum file upload size";
                // }
                // else{
                this.errorMessage = "Please make sure the file size does not exceed the maximum file upload size";
                // }
                break;
        }
    };
    SubSummaryComponent.prototype.requestDownloadFile = function (file) {
        var _this = this;
        this.attachmentService.downloadFile(file.AttachmentId).subscribe(function (data) {
            _this.setFileUrl(file, data);
        });
    };
    SubSummaryComponent.prototype.setFileUrl = function (file, data) {
        file.AttachmentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(data));
    };
    SubSummaryComponent.prototype.pushFileList = function (selectedItemId, columnName, fileList) {
        var _this = this;
        var item = this.summaryData.find(function (x) { return x[_this.idColumn] == selectedItemId; });
        var file = {
            id: selectedItemId + columnName,
            fileSummary: fileList
        };
        if (this.summaryFiles.findIndex(function (x) { return x.id == selectedItemId + columnName; }) > -1) {
            this.summaryFiles[this.summaryFiles.findIndex(function (x) { return x.id == selectedItemId + columnName; })] = file;
        }
        else {
            this.summaryFiles.push(file);
        }
    };
    SubSummaryComponent.prototype.getFileSummary = function (row, column) {
        var _this = this;
        if (this.summaryFiles.find(function (x) { return x.id == row[_this.idColumn] + column.PropertyName; })) {
            var fileSummary = this.summaryFiles.find(function (x) { return x.id == row[_this.idColumn] + column.PropertyName; }).fileSummary;
            if (fileSummary) {
                return fileSummary;
            }
            else {
                return [];
            }
        }
        else {
            return [];
        }
    };
    SubSummaryComponent.prototype.getFileReport = function (row, column) {
        var _this = this;
        this.isBusy = true;
        this.animate = false;
        this.summaryService.getFileReport(this.componentId, row[this.idColumn]).subscribe(function (result) {
            _this.isBusy = false;
            _this.animate = true;
            _this.downloadFileReport(row, column, result);
        }, function (error) {
            _this.isBusy = false;
            _this.animate = true;
        });
    };
    SubSummaryComponent.prototype.downloadFileReport = function (row, column, data) {
        var format = row["FileType"] ? row["FileType"] : ".pdf";
        this.workflowReturnService.downloadFile(data, row[column.PropertyName].split('|')[1] + '.' + format);
    };
    SubSummaryComponent.prototype.onContextMenu = function ($event, item) {
        if ($event.button == 0) {
            this.contextMenuService.show.next({
                contextMenu: this.basicMenu,
                event: $event,
                item: item,
            });
            this.actions = item;
        }
        $event.preventDefault();
        $event.stopPropagation();
    };
    SubSummaryComponent.prototype.summaryFunction = function (action, exportOption) {
        var _this = this;
        this.summaryService.summaryFunction(this.componentId, action.ActionType, exportOption).subscribe(function (result) {
            _this.handleWorkflowReturn(result);
        });
    };
    SubSummaryComponent.prototype.checkIfSummaryHasUpdate = function (insertBefore) {
        var _this = this;
        if (insertBefore === void 0) { insertBefore = false; }
        if (this.componentId) {
            this.summaryService.checkIfSummaryHasUpdate(this.componentId).subscribe(function (result) {
                if (result == "1") {
                    if (_this.fromBroadcast)
                        _this.summaryService.setHasNewMessages(true);
                    if (insertBefore && _this.fromBroadcast) {
                        _this.summaryService.getSummary(_this.componentId).subscribe(function (result) {
                            if (result) {
                                var newSummary = JSON.parse(result);
                                newSummary.Data.forEach(function (data) {
                                    if (_this.summaryData.findIndex(function (x) { return x[_this.idColumn] == data[_this.idColumn]; }) < 0) {
                                        _this.summaryData.unshift(data);
                                    }
                                });
                            }
                        });
                    }
                    else {
                        _this.showNoLoader = true;
                        _this.refreshCard(false);
                    }
                }
            });
        }
    };
    SubSummaryComponent.prototype.playSound = function () {
        var audio = new Audio("assets/sound/inflicted.mp3");
        audio.play();
    };
    return SubSummaryComponent;
}());
export { SubSummaryComponent };
